import QuoteTable from '../modules/quote_table/list_new'
import QuoteTable_Tips from '../modules/quote_table/list_tips'
import Param from '../modules/public_fun/param'
import cookie from '../modules/cookie'
import { checkIP, getCookie } from "../components/shared/utils"

var urlConfig = {
    host:'//push2.eastmoney.com'
}

if(Param.get('env') == 'test'){
    urlConfig.host = '//push2test.eastmoney.com'
}
var data = {
    table:null,
    timer:null,
    pz_size:20,
    is_ganggutong_fund: false,
    listMap:{
        hushengushi:{
            "url":'//push2.eastmoney.com/api/qt/clist/get?cb=?&ut=bd1d9ddb04089700cf9c27f6f7426281&fields=f1,f2,f3,f4,f5,f6,f7,f8,f9,f10,f12,f13,f14,f15,f16,f17,f18,f19,f20,f21,f23,f24,f25,f22,f11,f62,f104,f105,f111,f128,f136,f115,f148,f152&np=1&fltt=2&invt=2&pn=1',
            "hushenagu":{
                code:'m:0+t:6,m:0+t:13,m:0+t:80,m:1+t:2,m:1+t:23',
                tit:'沪深A股'
            },
            "shangzhengagu":{
                code:'m:1+t:2,m:1+t:23',
                tit:'上证A股'
            },
            "shenzhengagu":{
                code:'m:0+t:6,m:0+t:13,m:0+t:80',
                tit:'深证A股'
            },
            "beizhengagu":{
                code:'m:0+t:81+s:2048',
                tit:'北证A股'
            },
            "zhongxiaoban":{
                code:'m:0+t:13',
                tit:'中小板'
            },
            "chuangyeban":{
                code:'m:0+t:80',
                tit:'创业板'
            },
            "kechuangban":{
                code:'m:1+t:23',
                tit:'科创板'
            },
            "cdr":{
                code:'g:0+e:30,g:0+e:31,g:0+e:33,g:0+e:86',
                tit:'CDR'
            },
            "hushenzhishu":{
                code:'i:1.000001,i:1.000002,i:1.000003,i:1.000009,i:1.000010,i:1.000011,i:1.000012,i:1.000016,i:1.000300,i:1.000903,i:1.000905,i:1.000906,i:0.399001,i:0.399002,i:0.399003,i:0.399004,i:0.399005,i:0.399006,i:0.399100,i:0.399106,i:0.399305,i:0.399550,i:1.000688',
                tit:'沪深指数'
            },
            "shangzhengtuishi":{
                code:'m:1+f:2048',
                tit:'上证退市'
            },
            "shangzhengfengxian":{
                code:'m:1+f:4',
                tit:'上证风险'
            },
            "shenzhengtuishi":{
                code:'m:0+f:2048',
                tit:'深证退市'
            },
            "shenzhengfengxian":{
                code:'m:0+f:4',
                tit:'深证风险'
            },
            "kechuangfengxian":{
                code:'m:1+t:23+f:4',
                tit:'科创风险'
            },
            "chuangyebanfengxian":{
                code:'m:0+t:80+f:4',
                tit:'创业板风险'
            },
            "shangzhengbgu":{
                code:'m:1+t:3+f:!2',
                tit:'上证B股'
            },
            "shenzhengbgu":{
                code:'m:0+t:7+f:!2',
                tit:'深证B股'
            }
        },
        changneijijin:{
            "url":'//push2.eastmoney.com/api/qt/clist/get?cb=?&ut=bd1d9ddb04089700cf9c27f6f7426281&fields=f1,f2,f3,f4,f5,f6,f7,f8,f9,f10,f12,f13,f14,f15,f16,f17,f18,f19,f20,f21,f23,f24,f25,f22,f11,f62,f111,f128,f136,f115,f148,f152&np=1&fltt=2&invt=2&pn=1',
            "shangzhengjijin":{
                code:'m:1+t:9',
                tit:'上证基金'
            },
            "shenzhengjijin":{
                code:'m:0+t:10',
                tit:'深证基金'
            },
            "fenjijijin":{
                code:'b:MK0029,b:MK0030,b:MK0031',
                tit:'分级基金'
            },
            "etf":{
                code:'b:MK0021,b:MK0022,b:MK0023,b:MK0024',
                tit:'ETF'
            },
            "etf_hu":{
                code:'b:MK0839',
                tit:'ETF'
            },
            "etf_shen":{
                code:'b:MK0840',
                tit:'ETF'
            },
            'lof':{
                code:'b:MK0025,b:MK0026,b:MK0027,b:MK0028',
                tit:'LOF'
            },
            'fengbijijin':{
                code:'g:0+e:19',
                tit:'封闭基金'
            },
            'huobijijin':{
                code:'b:MK0413',
                tit:'货币基金'
            }
        },
        changwaijijin:{
            "url":'//push2.eastmoney.com/api/qt/clist/get?cb=?&ut=bd1d9ddb04089700cf9c27f6f7426281&fields=f1,f2,f3,f4,f5,f6,f7,f8,f9,f10,f12,f13,f14,f15,f16,f17,f18,f19,f20,f21,f23,f24,f25,f22,f11,f62,f111,f128,f136,f115,f148,f152&np=1&fltt=2&invt=2&pn=1',
            "quanbu":{
                code:'m:150',
                tit:'全部'
            },
            "huobixing":{
                code:'m:150+t:4',
                tit:'货币型'
            },
            "gupiaoxing":{
                code:'m:150+t:1,m:150+t:7',
                tit:'股票型'
            },
            "zhishuxing":{
                code:'m:150+t:7',
                tit:'指数型'
            },
            "zhaiquanxing":{
                code:'m:150+t:3,m:150+t:9',
                tit:'债券型'
            },
            "hunhexing":{
                code:'m:150+t:2,m:150+t:10',
                tit:'混合型'
            },
            "baobenxing":{
                code:'m:150+t:5,m:150+t:10',
                tit:'保本型'
            },
            "qdiixing":{
                code:'m:150+t:6',
                tit:'QDII型'
            },
        },
        zhaiquan:{
            "url":urlConfig.host + '/api/qt/clist/get?cb=?&ut=bd1d9ddb04089700cf9c27f6f7426281&fields=f1,f2,f3,f4,f5,f6,f7,f8,f9,f10,f12,f13,f14,f15,f16,f17,f18,f19,f20,f21,f23,f24,f25,f22,f11,f62,f115,f128,f136,f139,f148,f152,f247,f248,f352,f373,f414,f415,f416,f417,f418&np=1&fltt=2&invt=2&pn=1',
            "zhaiquanxianquan":{
                code:'m:1+t:4+e:7,m:1+t:4+e:8,m:1+t:4+e:9,m:1+t:4+e:10,m:1+t:4+e:11,m:1+t:4+e:12,m:0+t:8+e:7,m:0+t:8+e:8,m:0+t:8+e:9,m:0+t:8+e:10,m:0+t:8+e:11,m:0+t:8+e:12',
                tit:'债券现券'
            },
            "shangzhengzhaiquan":{
                code:'m:1+t:4+e:7,m:1+t:4+e:8,m:1+t:4+e:9,m:1+t:4+e:10,m:1+t:4+e:11,m:1+t:4+e:12',
                tit:'上证债券'
            },
            "shenzhengzhaiquan":{
                code:'m:0+t:8+e:7,m:0+t:8+e:8,m:0+t:8+e:9,m:0+t:8+e:10,m:0+t:8+e:11,m:0+t:8+e:12',
                tit:'深证债券'
            },
            "beijingbond":{
                code:'m:0+t:35',
                tit:'北证债券'
            },
            "guozhai":{
                code:'b:MK0351',
                tit:'国债'
            },
            "difangzhai":{
                code:'b:MK0352',
                tit:'地方债'
            },
            "qiyezhai":{
                code:'b:MK0353',
                tit:'企业债'
            },
            "kezhuanzhai":{
                code:'b:MK0354',
                tit:'可转债'
            },
            "zhaiquanhuigou":{
                code:'b:MK0356',
                tit:'质押式回购'
            },
            "gongsizhai":{
                code:'b:MK0357',
                tit:'公司债'
            }
        },
        quanqiuguozhai:{
            "url":urlConfig.host +'/api/qt/clist/get?cb=?&ut=bd1d9ddb04089700cf9c27f6f7426281&fields=f1,f2,f3,f4,f5,f6,f7,f12,f13,f14,f15,f16,f17,f18,f28,f31,f32,f108,f124,f152,f163,f277,f350,f486,f487,f488,f489,f490,f491,f492,f493,f495,f497,f498,f499,f753&np=1&fltt=2&invt=2&pn=1&pi=0&fs=',
            "globaltips":{
                code:'m:171+y:1+p:1',
                tips_selector_code:{
                    tips_country:"",
                    tips_duration:"",
                    tips_currency:"",
                },
                tit:'关键期限国债'
            },
            "ustips":{
                code:'m:171+t:2+p:1',
                tit:'关键期限美债'
            },
            "globalbond":{
                code:'m:171+y:2+p:1',
                tit:'全球国债'
            },
            "usbond":{
                code:'m:171+y:2+n:US+p:1',
                tit:'美国债个券'
            },
            "usprerelease":{
                code:'m:171+t:3+n:US',
                tit:'美国债预发行'
            },
            "usfutures":{
                code:'m:103+t:13+p:1,m:103+t:14+p:1,m:103+t:15+p:1,m:103+t:16+p:1,m:103+t:17+p:1',
                tit:'美国债期货'
            },
        },
        hushengangtong:{
            "url":'//push2.eastmoney.com/api/qt/clist/get?cb=?&ut=bd1d9ddb04089700cf9c27f6f7426281&fields=f1,f2,f3,f4,f5,f6,f7,f8,f9,f10,f12,f13,f14,f15,f16,f17,f18,f19,f20,f21,f23,f24,f25,f22,f11,f62,f111,f128,f136,f115,f148,f152,f186,f187,f188,f190&np=1&fltt=2&invt=2&pn=1',
            "ahguyijia":{
                code:'b:DLMK0101',
                tit:'AH股溢价'
            },
            "hugutong":{
                code:'b:BK0707',
                tit:'沪股通(港>沪)'
            },
            "hugutong_fund":{
                code:'b:MK0839',
                tit:'沪股通(港>沪)'
            },
            "ganggutonghu":{
                code:'b:DLMK0144',
                tit:'港股通(沪>港)'
            },
            "ganggutonghu_fund":{
                code:'b:MK0838',
                tit:'港股通(沪>港)'
            },
            "shengutong":{
                code:'b:BK0804',
                tit:'深股通(港>深)'
            },
            "shengutong_fund":{
                code:'b:MK0840',
                tit:'深股通(港>深)'
            },
            "ganggutongshen":{
                code:'b:DLMK0146',
                tit:'港股通(深>港)'
            },
            "ganggutongshen_fund":{
                code:'b:MK0837',
                tit:'港股通(深>港)'
            }
        },
        huluntong:{
            "url":'//push2.eastmoney.com/api/qt/clist/get?cb=?&ut=bd1d9ddb04089700cf9c27f6f7426281&fields=f1,f2,f3,f4,f5,f6,f7,f8,f9,f10,f12,f13,f14,f15,f16,f17,f18,f19,f20,f21,f23,f24,f25,f22,f11,f62,f111,f115,f117,f118,f119,f120,f128,f136,f148,f152,f186,f187,f188,f189,f190&np=1&fltt=2&invt=2&pn=1',
            "cdr":{
                code:'b:m:1+e:31',
                tit:'CDR'
            },
            "gdr":{
                code:'b:MK0815',
                tit:'GDR'
            },
            "gdrayijia":{
                code:'b:MK0815',
                tit:'GDR/A溢价'
            },
            "cdryingyijia":{
                code:'m:1+e:31',
                tit:'CDR/英溢价'
            }
        },
        reits:{
            "url":'//push2.eastmoney.com/api/qt/clist/get?cb=?&ut=bd1d9ddb04089700cf9c27f6f7426281&fields=f1,f2,f3,f4,f5,f6,f7,f8,f9,f10,f12,f13,f14,f15,f16,f17,f18,f19,f20,f21,f23,f24,f25,f22,f11,f62,f111,f115,f117,f118,f119,f120,f128,f136,f148,f152,f186,f187,f188,f189,f190&np=1&fltt=2&invt=2&pn=1',
            "hsjcss":{
                code:'m:0+t:10+e:97,m:1+t:9+e:97',
                tit:'沪深基础设施REITs'
            },
            "shjcss":{
                code:'m:1+t:9+e:97',
                tit:'上交所基础设施REITs'
            },
            "szhcss":{
                code:'m:0+t:10+e:97',
                tit:'深交所基础设施REITs'
            }
        }
    },
    tips_selectors:{
        tips_country:{
            "全部":{
                value:"n:ALL",
                selected:true,
            },
            "中国":{
                value:"n:CN",
                selected:false,
            },
            "美国":{
                value:"n:US",
                selected:false,
            },
            "英国":{
                value:"n:GB",
                selected:false,
            },
            "法国":{
                value:"n:FR",
                selected:false,
            },
            "德国":{
                value:"n:DE",
                selected:false,
            },
            "韩国":{
                value:"n:KR",
                selected:false,
            },
            "意大利":{
                value:"n:IT",
                selected:false,
            },
            "澳大利亚":{
                value:"n:AU",
                selected:false,
            },
            "印度":{
                value:"n:IN",
                selected:false,
            },
            "中国香港":{
                value:"n:HK",
                selected:false,
            },
            "俄罗斯":{
                value:"n:RU",
                selected:false,
            },
            "其他":{
                value:"n:!CN+n:!US+n:!GB+n:!FR+n:!DE+n:!KR+n:!IT+n:!AU+n:!IN+n:!HK+n:!RU",
                selected:false,
            },
        },
        tips_duration:{
            "全部":{
                value:"r:ALL",
                selected:true,
            },
            "1月":{
                value:"r:1M",
                selected:false,
            },
            "2月":{
                value:"r:2M",
                selected:false,
            },
            "3月":{
                value:"r:3M",
                selected:false,
            },
            "4月":{
                value:"r:4M",
                selected:false,
            },
            "6月":{
                value:"r:6M",
                selected:false,
            },
            "12月":{
                value:"r:12M",
                selected:false,
            },
            "2年":{
                value:"r:2Y",
                selected:false,
            },
            "3年":{
                value:"r:3Y",
                selected:false,
            },
            "4年":{
                value:"r:4Y",
                selected:false,
            },
            "5年":{
                value:"r:5Y",
                selected:false,
            },
            "6年":{
                value:"r:6Y",
                selected:false,
            },
            "7年":{
                value:"r:7Y",
                selected:false,
            },
            "8年":{
                value:"r:8Y",
                selected:false,
            },
            "9年":{
                value:"r:9Y",
                selected:false,
            },
            "10年":{
                value:"r:10Y",
                selected:false,
            },
            "11年":{
                value:"r:11Y",
                selected:false,
            },
            "12年":{
                value:"r:12Y",
                selected:false,
            },
            "15年":{
                value:"r:15Y",
                selected:false,
            },
            "20年":{
                value:"r:20Y",
                selected:false,
            },
            "25年":{
                value:"r:25Y",
                selected:false,
            },
            "30年":{
                value:"r:30Y",
                selected:false,
            },
            "40年":{
                value:"r:40Y",
                selected:false,
            },
            "50年":{
                value:"r:50Y",
                selected:false,
            }
        },
        tips_currency:{
            "全部":{
                value:"u:ALL",
                selected:true,
            },
            "欧元":{
                value:"u:EUR",
                selected:false,
            },
            "美元":{
                value:"u:USD",
                selected:false,
            },
            // "日元":{
            //     value:"u:JPY",
            //     selected:false,
            // },
            "港币":{
                value:"u:HKD",
                selected:false,
            },
            "卢布":{
                value:"u:RUB",
                selected:false,
            },
            "人民币":{
                value:"u:CNY",
                selected:false,
            },
            "澳元":{
                value:"u:AUD",
                selected:false,
            },
            "英镑":{
                value:"u:GBP",
                selected:false,
            },
            "卢比":{
                value:"u:INR",
                selected:false,
            },
            "韩元":{
                value:"u:KRW",
                selected:false,
            },
            "离岸人民币":{
                value:"u:CNH",
                selected:false,
            },
            "其他":{
                value:"u:!EUR+u:!USD+u:!JPY+u:!HKD+u:!RUB+u:!CNY+u:!AUD+u:!GBP+u:!INR+u:!KRW+u:!CNH",
                selected:false,
            },
        },
    },
    current_tips_selector:-1,
    quote_color_reverse:cookie.get("quote_color_rever") == "1",
    init:function(){
        // 初始化
        let self = this
        
        let params = Param.get('mt')
        params = params.split('_')
        let mkname = params[0]
        let listname = params[1]
        if(params[2]){
            listname = params[1]+'_'+params[2]
        }
        self.loadTit(mkname,listname)
        self.initTable(mkname,listname)
        self.bindFun()
    },
    loadTit:function(mkname,listname){
        let self = this
        $('#market-title').html(`${self.listMap[mkname][listname].tit}`)
    },
    bindFun:function(){
        let self = this
        $('#list-loadmore').on('click',async function(){
            try {
                let data = await self.table.showMore(20)
                self.pz_size +=20
                let dataNum = data.data.diff.length
                if(self.pz_size > dataNum){
                    $("#list-loadmore").html('已经到底了')
                }
            } catch (error) {
                $("#list-loadmore").html('暂无数据')
            }
        })
    },
    getUrl:function(mkname,listname){
        // 获取请求地址
        let self = this
        let url = `${self.listMap[mkname].url}&fs=${self.listMap[mkname][listname].code}`
        return url
    },
    moreData:async function(){
        let self = this
        try {
            let data = await self.table.loadDataLength()
            let dataNum = data.data.diff.length
            if(dataNum < 20){
                $("#list-loadmore").html('已经到底了')
            }
        } catch (error) {
            $("#list-loadmore").html('暂无数据')
        }
    },
    initTable:function(mkname,listname){
        let self = this
        let url = self.getUrl(mkname,listname)
        if(mkname == 'hushengushi'){
            if(listname == 'hushenzhishu'){
                self.table = self.makehushenzhishuTable(url)
            }else{
                self.table = self.makehushenTable(url)
            }
        }else if(mkname == 'changneijijin' || mkname == 'reits'){
            self.table = self.makechangneiTable(url)
            if(listname.indexOf('etf') > -1){
                if(navigator.userAgent.toLowerCase().indexOf('ipad') > -1 || navigator.userAgent.toLowerCase().indexOf('pad') > -1){
                    $("#hqlist-wrap").css('padding-top','6.5rem')
                }else{
                    $("#hqlist-wrap").css('padding-top','8rem')
                }
                $("#hqlisttab").hide()
                $("#hqlisttab-etf").show()
                $("#etf-all-list").on('click',function(){
                    location.search = "?mt=changneijijin_etf"
                })
                $("#etf-hu-list").on('click',function(){
                    location.search = "?mt=changneijijin_etf_hu"
                })
                $("#etf-shen-list").on('click',function(){
                    location.search = "?mt=changneijijin_etf_shen"
                })
            }
        }else if(mkname == 'changwaijijin'){
            if(listname == 'huobixing'){
                self.table = self.makechangwaihuobiTable(url)
            }else{
                self.table = self.makechangwaiTable(url)
            }
        }else if(mkname == 'zhaiquan'){
            if(listname == 'zhaiquanhuigou'){
                self.table = self.makechangzhaiquanhuigouTable(url)
            }else if(listname == 'kezhuanzhai'){
                self.table = self.makechangzhaiquanTable(url)
            }else{
                self.table = self.makezhaiquanTable(url)
            }
        }else if(mkname == 'quanqiuguozhai'){
            if(listname.indexOf('globaltips') > -1){
                if(navigator.userAgent.toLowerCase().indexOf('ipad') > -1 || navigator.userAgent.toLowerCase().indexOf('pad') > -1){
                    $("#hqlist-wrap").css('padding-top','9.5rem')
                }else{
                    $("#hqlist-wrap").css('padding-top','10.5rem')
                }
                $("#hqlist-tips-tab").show()
                self.clickTipsSelector()
                
                let tips_url = self.getTipsUrl(mkname,listname)
                self.table = self.makeGlobalTipsTable(tips_url)
                self.resetTipsSelector(mkname,listname)
                self.confirmTipsSelector(mkname,listname)
                $("#tips-layer").on('click',function(){
                    self.closeTipsSelector()
                })
            }else if(listname.indexOf('ustips') > -1){
                let url = `${self.listMap[mkname].url}${self.listMap[mkname][listname].code}`
                self.table = self.makeUSTipsTable(url)
            }else if(listname.indexOf('globalbond') > -1){
                let self = this
                let data = self.tips_selectors["tips_country"]
                self.renderGlobalBondTabs(data)
                
                let url = `${self.listMap[mkname].url}${self.listMap[mkname][listname].code}`
                self.table = self.makeGlobalBondTable(url)
                
                $("#global-bond-layer").on('click',function(){
                    self.closeCountrySelector()
                })
            }else if(listname.indexOf('usbond') > -1){
                let self = this
                let data = self.tips_selectors["tips_country"]
                data["全部"].selected = false
                data["美国"].selected = true
                self.renderGlobalBondTabs(data)

                let url = `${self.listMap[mkname].url}${self.listMap[mkname][listname].code}`
                self.table = self.makeGlobalBondTable(url)
                
                $("#global-bond-layer").on('click',function(){
                    self.closeCountrySelector()
                })
            }else if(listname.indexOf('usprerelease') > -1){
                let self = this
                let url = `${self.listMap[mkname].url}${self.listMap[mkname][listname].code}`
                self.table = self.makeUSPreReleaseTable(url)
            }else if(listname.indexOf('usfutures') > -1){
                let self = this
                let url = `${self.listMap[mkname].url}${self.listMap[mkname][listname].code}`
                self.table = self.makeUSFuturesTable(url)
            }
        }else if(mkname == 'hushengangtong'){
            if(listname == 'ahguyijia'){
                // $("#hqlist-wrap").css({"padding-top":"4.5rem"})
                self.table = self.makehushengangtongAhTable(url)
            }else{
                $("#hqlisttab-etf").hide()
                $("#hqlisttab").show()
                if(navigator.userAgent.toLowerCase().indexOf('ipad') > -1 || navigator.userAgent.toLowerCase().indexOf('pad') > -1){
                    $("#hqlist-wrap").css('padding-top','6.5rem')
                }else{
                    $("#hqlist-wrap").css({"padding-top":"8rem"})
                }
                if(listname.indexOf('hugutong') > -1){
                    $("#hgt-single-stock-list").on('click',function(){
                        location.search = "?mt=hushengangtong_hugutong"
                    })
                    $("#hgt-single-fund-list").on('click',function(){
                        location.search = "?mt=hushengangtong_hugutong_fund"
                    })
                }else if(listname.indexOf('shengutong') > -1){
                    $("#hgt-single-stock-list").on('click',function(){
                        location.search = "?mt=hushengangtong_shengutong"
                    })
                    $("#hgt-single-fund-list").on('click',function(){
                        location.search = "?mt=hushengangtong_shengutong_fund"
                    })
                }else if(listname.indexOf('ganggutonghu') > -1){
                    self.is_ganggutong_fund = true
                    $("#hgt-single-stock-list").on('click',function(){
                        location.search = "?mt=hushengangtong_ganggutonghu"
                    })
                    $("#hgt-single-fund-list").on('click',function(){
                        location.search = "?mt=hushengangtong_ganggutonghu_fund"
                    })
                }else if(listname.indexOf('ganggutongshen') > -1){
                    self.is_ganggutong_fund = true
                    $("#hgt-single-stock-list").on('click',function(){
                        location.search = "?mt=hushengangtong_ganggutongshen"
                    })
                    $("#hgt-single-fund-list").on('click',function(){
                        location.search = "?mt=hushengangtong_ganggutongshen_fund"
                    })
                }
                self.table = self.makehushengangtongTable(url)
            }
        }else if(mkname == 'huluntong'){
            if(listname == 'gdrayijia'){
                self.table = self.makehuluntongyijiagdrTable(url)
            }else if(listname == 'cdryingyijia'){
                self.table = self.makehuluntongyijiacdrTable(url)
            }else{
                self.table = self.makehuluntongTable(url)
            }
        }
    },
    getTipsUrl:function(mkname:string,listname:string){
        // 获取请求地址
        let self = this
        let fsArr = Array.from(Object.values(self.listMap[mkname][listname].tips_selector_code),x=>x)
        let filterArr = fsArr.filter(Boolean)
        let url = `${self.listMap[mkname].url}${self.listMap[mkname][listname].code}${filterArr.length?"+"+filterArr.join("+"):""}`
        return url
    },
    getGlobalBondUrl:function(selectedCode:string){
        let self = this
        let url = `${self.listMap["quanqiuguozhai"].url}${self.listMap["quanqiuguozhai"]["globalbond"].code}+${selectedCode}`
        return url
    },
    closeTipsSelector:function(){
        let self = this
        $("#tips-selector").removeClass("tips-selector-show")
        $("#tips-layer").hide()
        $("#hqlist-tips-tab li")[self.current_tips_selector].classList.remove("tab-item-active")
        $("#hqlist-tips-tab li p")[self.current_tips_selector].classList.remove("tab-item-active")
        $("#hqlist-tips-tab li i")[self.current_tips_selector].classList.remove("active","rotate")
        self.current_tips_selector = -1
    },
    resetTipsSelector:function(mkname:string,listname:string){
        let self = this
        $("#tips-reset").on('click',function(){
            let currentSelector:any = $("#hqlist-tips-tab li.tab-item-active")
            let type = currentSelector?.[0]?.id
            Object.keys(self.tips_selectors[type]).map((item:any,index:number)=>{
                if(item == '全部'){
                    self.tips_selectors[type][item].selected = true
                }else{
                    self.tips_selectors[type][item].selected = false
                }
            })
            self.renderTipsSelector(self.tips_selectors[type],type)
            self.listMap[mkname][listname].tips_selector_code[type] = ""
            $(`#${type} p`).html('全部')
        })
    },
    confirmTipsSelector:function(mkname:string,listname:string){
        let self = this
        $("#tips-confirm").on('click',function(){
            // 清除旧列表
            clearInterval(self.table.timer)
            self.table = null
            let currentSelector:any = $("#hqlist-tips-tab li.tab-item-active")
            let type = currentSelector?.[0]?.id
            let fs_temp:any = []
            let selectedItems:string[] = []
            Object.keys(self.tips_selectors[type]).map((item:any,index:number)=>{
                if(self.tips_selectors[type][item].selected){
                    fs_temp.push(self.tips_selectors[type][item].value)
                    selectedItems.push(item)
                }  
            })
            if(fs_temp.length){
                self.listMap[mkname][listname].tips_selector_code[type] = fs_temp.join('+')
                $(`#${type} p`).html(selectedItems.join(","))
            }else{
                self.listMap[mkname][listname].tips_selector_code[type] = ""
                $(`#${type} p`).html("全部")
            }
            let url = self.getTipsUrl(mkname,listname)
            self.table = self.makeGlobalTipsTable(url)
            self.pz_size = 20
            $("#list-loadmore").html('查看更多<i class="arrow-down"></i>')
            self.closeTipsSelector()
        })
    },
    clickTipsSelector:function(){
        let self = this
        let tipsTabs = $("#hqlist-tips-tab li")
        tipsTabs.map((index:number,item:any)=>{
            item.onclick = function clickTabItem(){
                if(self.current_tips_selector == index){
                    $("#tips-selector").removeClass("tips-selector-show")
                    $("#tips-layer").hide()
                    item.classList.remove("tab-item-active")
                    $("#hqlist-tips-tab li p")[index].classList.remove("tab-item-active")
                    $("#hqlist-tips-tab li i")[index].classList.remove("active","rotate")
                    self.current_tips_selector = -1
                }else{
                    self.renderTipsSelector(self.tips_selectors[item.id],item.id)
                    item.classList.add("tab-item-active")
                    $("#hqlist-tips-tab li p")[index].classList.add("tab-item-active")
                    $("#hqlist-tips-tab li i")[index].classList.add("active","rotate")
                    tipsTabs.map((index2:number,item2:any)=>{
                        if(index2 != index){
                            item2.classList.remove("tab-item-active")
                            $("#hqlist-tips-tab li p")[index2].classList.remove("tab-item-active")
                            $("#hqlist-tips-tab li i")[index2].classList.remove("active","rotate")
                        }
                    })
                    self.current_tips_selector = index
                } 
            }
        })    
    },
    renderTipsSelector:function(data,type){
        let self = this
        let template = "<dl>"
        Object.keys(data).map((item:any,index:number)=>{
            template += `
                <dd class='tips-selector-item ${data[item].selected ?"tips-item-active":""}' name='${type}' value='${index}'>
                    ${item}
                </dd>`
        })
        template += "</dl>"
        $("#tips-selector").addClass("tips-selector-show")
        $(".comm-nav")[0].style.zIndex = "10000"
        $("#tips-selector-container").html(template);
        $("#tips-layer").show()
        // 禁止默认事件
        $("#tips-layer").on('touchmove', function(e) {
            e.preventDefault();
            e.stopPropagation();
        });
        $("#tips-selector").on('touchmove', function(e) {
            e.preventDefault();
            e.stopPropagation();
        });
        self.tipsDataCheck($(`dd[name=${type}]`),data)
    },
    tipsDataCheck:function(elements:any,data:any){
        let self = this
        elements.map((index:number,v:any)=>{
            v.onclick = function onTipsDataCheck(){
                if(index != 0){
                    elements[0].classList.remove("tips-item-active")
                    if(elements[index].className.indexOf("tips-item-active") > -1){
                        elements[index].classList.remove("tips-item-active")
                        data[v.innerText].selected = false
                        // data[elements[0].innerText].selected = true
                    }else{
                        elements[index].classList.add("tips-item-active")
                        data[v.innerText].selected = true
                        data[elements[0].innerText].selected = false
                    }
                }else if(index == 0){
                    elements[0].classList.add("tips-item-active")
                    data[v.innerText].selected = true
                    elements.map((index1:number,v1:any)=>{
                        if(index1 != 0){
                            v1.classList.remove("tips-item-active")
                            data[v1.innerText].selected = false
                        }
                    })
                }
            }
         })
    },
    renderGlobalBondTabs:function(data:any){
        let self = this
        let template_tabs = ""
        Object.keys(data).map((item:any,index:number)=>{
            if(index < 6){
                template_tabs += `
                <li class='${data[item].selected ?"tips-item-active":""}' name='country' value='${index}'>
                    ${item}
                </li>`
            }
        })
        template_tabs += '<li id="country-more"><a href="#" class="country-more-icon"></a></li>'
        $("#country-tabs").show()
        $("#country-tabs").html(template_tabs);
        self.globalBondTabsDataCheck($(`li[name=country]`),data) 
        $("#country-more").on('click',function(){
            self.renderGlobalBondSelector(data)
        })
        $("#country-cancel-btn").on('click',function(){
            self.closeCountrySelector()
        })
    },
    globalBondTabsDataCheck:function(elements:any,data:any){
        let self = this
        elements.map((index:number,v:any)=>{
            v.onclick = function onGlobalBondTabsDataCheck(){
                // 清除旧列表
                clearInterval(self.table.timer)
                self.table = null
                v.classList.add("tips-item-active")
                data[v.innerText].selected = true
                elements.map((index1:number,v1:any)=>{
                    if(index1 != index){
                        v1.classList.remove("tips-item-active")
                        data[v1.innerText].selected = false
                    }
                })
                Object.keys(data).map((item:any)=>{
                    if(item != v.innerText){
                        data[item].selected = false
                    }
                })
                let url = self.getGlobalBondUrl(data[v.innerText].value)
                self.table = self.makeGlobalBondTable(url)
            }
         })
    },
    renderGlobalBondSelector:function(data:any){
        let self = this
        let template = "<dl>"
        Object.keys(data).map((item:any,index:number)=>{
            template += `
                <dd class='tips-selector-item ${data[item].selected ?"tips-item-active":""}' name='country' value='${index}'>
                    ${item}
                </dd>`
        })
        template += "</dl>"
        $("#country-selector").addClass("country-selector-show")
        $("#country-selector-container").html(template);
        $("#global-bond-layer").show()
        $("#country-tabs").hide()
        self.globalBondSelectorDataCheck($(`dd[name=country]`),data,)
    },
    globalBondSelectorDataCheck:function(elements:any,data:any){
        let self = this
        elements.map((index:number,v:any)=>{
            v.onclick = function onGlobalBondSelectorDataCheck(){
                clearInterval(self.table.timer)
                self.table = null
                v.classList.add("tips-item-active")
                data[v.innerText].selected = true
                elements.map((index1:number,v1:any)=>{
                    if(index1 != index){
                        v1.classList.remove("tips-item-active")
                        data[v1.innerText].selected = false
                    }
                }) 
                let url = self.getGlobalBondUrl(data[v.innerText].value)
                self.table = self.makeGlobalBondTable(url)
                self.closeCountrySelector()
                self.renderGlobalBondTabs(data)
            }
         })
    },
    closeCountrySelector:function(){
        $("#country-selector").removeClass("country-selector-show")
        $("#global-bond-layer").hide()
        $("#country-tabs").show()
    },
    makehushenTable: function(url) {
        let self = this
        let quotetable = new QuoteTable({
            ele: 'listtable',
            api: `${url}`,
            params: { // 默认参数配置
                sortkey: Param.get("sorttype") == "cjb" ? 'f6' : 'f3',
                sortval: '1',
                size: '20'
            },
            right_tds: 3,
            refresh: 15,
            sortdesc:'1',
            sortacr:'0',
            item: [
                {
                    name: 'name',
                    title: '名称',
                    html: function (data) {
                        if (data == null) {
                            return `<th>${this.title}</th>`
                        } else {
                            let icon = ''
                            if ((data.f13 == 1) && (data.f19 == 23)) {
                                icon = icon + "<span class='icon-kc'>科创</span>"
                            }
                            if ((data.f13 == 0) && (data.f111 & 2048)){
                                icon = icon + "<span class='icon-kc'>京</span>"
                            }
                            if (data.f148 & 64) {
                                icon = icon + "<span class='icon-rz'>融</span>"
                            }
                            return `<td><p>${data.f14}</p><p>${data.f12}${icon}</p></td>`
                        }
                    },
                    sort: false
                },
                {
                    name: 'zx',
                    title: '最新',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th value="true" class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td class="${data.f3 > 0 ? 'shares-rise' : (data.f3<0?'shares-fall':'') }">${self.numberFix(data.f2,data.f1)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f2'
                    }
                },
                {
                    name: 'zf',
                    title: '涨幅',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="${Param.get("sorttype") == "cjb" ? 'sort_normal' : 'sort_des'}">${this.title}</th>`
                        } else {
                            return `<td class="${data.f3 > 0 ? 'shares-rise' : (data.f3<0?'shares-fall':'') }">${self.dataProcess(data.f3,data.f152,'%')}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '0',
                        ascvalue: '1',
                        key: 'f3'
                    }
                },
                {
                    name: 'zd',
                    title: '涨跌',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td class="${data.f4 > 0 ? 'shares-rise' : (data.f4<0?'shares-fall':'') }">${self.numberFix(data.f4,data.f1)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f4'
                    }
                },
                {
                    name: 'zs',
                    title: '涨速',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td class="${data.f22 > 0 ? 'shares-rise' : (data.f22<0?'shares-fall':'') }">${self.dataProcess(data.f22,data.f152,'%')}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f22'
                    }
                },
                {
                    name: 'hs',
                    title: '换手',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td>${self.dataProcess(data.f8,data.f152,'%')}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f8'
                    }
                },
                {
                    name: 'zl',
                    title: '总量',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td>${self.conversion(data.f5,false,true,true)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f5'
                    }
                },
                {
                    name: 'je',
                    title: '金额',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="${Param.get("sorttype") == "cjb" ? 'sort_des' : 'sort_normal'}">${this.title}</th>`
                        } else {
                            return `<td>${self.conversion(data.f6,false,true)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f6'
                    }
                },
                {
                    name: 'lb',
                    title: '量比',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td>${self.numberFix(data.f10,data.f152)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f10'
                    }
                },
                {
                    name: 'zg',
                    title: '最高',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td class="${data.f15 > data.f18 ? 'shares-rise' : (data.f15 < data.f18?'shares-fall':'') }">${self.numberFix(data.f15,data.f1)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f15'
                    }
                },
                {
                    name: 'zd',
                    title: '最低',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td class="${data.f16 > data.f18 ? 'shares-rise' : (data.f16 < data.f18?'shares-fall':'') }">${self.numberFix(data.f16,data.f1)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f16'
                    }
                },
                {
                    name: 'zf',
                    title: '振幅',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td>${self.dataProcess(data.f7,data.f152,'%')}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f7'
                    }
                },{
                    name: 'jnzf',
                    title: '今年涨幅',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td class="${data.f25 > 0 ? 'shares-rise' : (data.f25<0?'shares-fall':'') }">${self.dataProcess(data.f25,data.f152,'%')}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f25'
                    }
                },{
                    name: 'syl',
                    title: '市盈率',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td>${self.numberFix(data.f9,data.f152)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f9'
                    }
                },{
                    name: 'sjl',
                    title: '市净率',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td>${self.numberFix(data.f23,2)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f23'
                    }
                },{
                    name: 'zsz',
                    title: '总市值',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td>${ self.conversion(data.f20,false,true)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f20'
                    }
                },{
                    name: 'ltsz',
                    title: '流通市值',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td>${ self.conversion(data.f21,false,true)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f21'
                    }
                }
            ]
        })
        let data = quotetable.init(true)
        data.then(function(e){
            if(e == undefined || e.data == null){
                $("#list-loadmore").html('暂无数据')
            }
        })
        return quotetable
    },
    makehushenzhishuTable: function(url) {
        let self = this
        let quotetable = new QuoteTable({
            ele: 'listtable',
            api: `${url}`,
            params: { // 默认参数配置
                sortkey: 'f3',
                sortval: '1',
                size: '20'
            },
            right_tds: 3,
            refresh: 15,
            sortdesc:'1',
            sortacr:'0',
            item: [
                {
                    name: 'name',
                    title: '名称',
                    html: function (data) {
                        if (data == null) {
                            return `<th>${this.title}</th>`
                        } else {
                            let icon = ''
                            if ((data.f13 == 1) && (data.f19 == 23)) {
                                icon = icon + "<span class='icon-kc'>科创</span>"
                            }
                            if ((data.f13 == 0) && (data.f111 & 2048)){
                                icon = icon + "<span class='icon-kc'>京</span>"
                            }
                            if (data.f148 & 64) {
                                icon = icon + "<span class='icon-rz'>融</span>"
                            }
                            return `<td><p>${data.f14}</p><p>${data.f12}${icon}</p></td>`
                        }
                    },
                    sort: false
                },
                {
                    name: 'zx',
                    title: '最新',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th value="true" class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td class="${data.f3 > 0 ? 'shares-rise' : (data.f3<0?'shares-fall':'') }">${self.numberFix(data.f2,data.f1)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f2'
                    }
                },
                {
                    name: 'zf',
                    title: '涨幅',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_des">${this.title}</th>`
                        } else {
                            return `<td class="${data.f3 > 0 ? 'shares-rise' : (data.f3<0?'shares-fall':'') }">${self.dataProcess(data.f3,data.f152,'%')}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '0',
                        ascvalue: '1',
                        key: 'f3'
                    }
                },
                {
                    name: 'zd',
                    title: '涨跌',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td class="${data.f4 > 0 ? 'shares-rise' : (data.f4<0?'shares-fall':'') }">${self.numberFix(data.f4,data.f1)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f4'
                    }
                },
                {
                    name: 'zdjs',
                    title: '涨跌家数',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td>${data.f104}/${data.f105}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f104'
                    }
                },
                {
                    name: 'zs',
                    title: '涨速',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td class="${data.f22 > 0 ? 'shares-rise' : (data.f22<0?'shares-fall':'') }">${self.dataProcess(data.f22,data.f152,'%')}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f22'
                    }
                },
                {
                    name: 'je',
                    title: '金额',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td>${self.conversion(data.f6,false,true)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f6'
                    }
                },
                {
                    name: 'zl',
                    title: '总手',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td>${self.conversion(data.f5,false,true,true)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f5'
                    }
                },
                {
                    name: 'hs',
                    title: '换手',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td>${self.dataProcess(data.f8,data.f152,'%')}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f8'
                    }
                },
                {
                    name: 'lb',
                    title: '量比',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td>${self.numberFix(data.f10,data.f152)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f10'
                    }
                },
                {
                    name: 'zf',
                    title: '振幅',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td>${self.dataProcess(data.f7,data.f152,'%')}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f7'
                    }
                },{
                    name: 'jnzf',
                    title: '今年涨幅',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td class="${data.f25 > 0 ? 'shares-rise' : (data.f25<0?'shares-fall':'') }">${self.dataProcess(data.f25,data.f152,'%')}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f25'
                    }
                },{
                    name: 'zsz',
                    title: '总市值',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td>${ self.conversion(data.f20,false,true)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f20'
                    }
                },{
                    name: 'ltsz',
                    title: '流通市值',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td>${ self.conversion(data.f21,false,true)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f21'
                    }
                }
            ]
        })
        let data = quotetable.init(true)
        data.then(function(e){
            if(e == undefined || e.data == null){
                $("#list-loadmore").html('暂无数据')
            }
        })
        return quotetable
    },
    makechangneiTable: function(url) {
        let self = this
        let quotetable = new QuoteTable({
            ele: 'listtable',
            api: `${url}`,
            params: { // 默认参数配置
                sortkey: 'f3',
                sortval: '1',
                size: '20'
            },
            right_tds: 3,
            refresh: 15,
            sortdesc:'1',
            sortacr:'0',
            item: [
                {
                    name: 'name',
                    title: '名称',
                    html: function (data) {
                        if (data == null) {
                            return `<th>${this.title}</th>`
                        } else {
                            let icon = ''
                            if ((data.f13 == 1) && (data.f19 == 23)) {
                                icon = icon + "<span class='icon-kc'>科创</span>"
                            }
                            if ((data.f13 == 0) && (data.f111 & 2048)){
                                icon = icon + "<span class='icon-kc'>京</span>"
                            }
                            if (data.f148 & 64) {
                                icon = icon + "<span class='icon-rz'>融</span>"
                            }
                            return `<td><p>${data.f14}</p><p>${data.f12}${icon}</p></td>`
                        }
                    },
                    sort: false
                },
                {
                    name: 'zx',
                    title: '最新',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th value="true" class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td class="${data.f3 > 0 ? 'shares-rise' : (data.f3<0?'shares-fall':'') }">${self.numberFix(data.f2,data.f1)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f2'
                    }
                },
                {
                    name: 'zf',
                    title: '涨幅',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_des">${this.title}</th>`
                        } else {
                            return `<td class="${data.f3 > 0 ? 'shares-rise' : (data.f3<0?'shares-fall':'') }">${self.dataProcess(data.f3,data.f152,'%')}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '0',
                        ascvalue: '1',
                        key: 'f3'
                    }
                },
                {
                    name: 'zd',
                    title: '涨跌',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td class="${data.f4 > 0 ? 'shares-rise' : (data.f4<0?'shares-fall':'') }">${self.numberFix(data.f4,data.f1)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f4'
                    }
                },
                {
                    name: 'zl',
                    title: '总手',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td>${self.conversion(data.f5,false,true,true)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f5'
                    }
                },
                {
                    name: 'je',
                    title: '金额',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td>${self.conversion(data.f6,false,true)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f6'
                    }
                },
                {
                    name: 'lb',
                    title: '量比',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td>${self.numberFix(data.f10,data.f152)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f10'
                    }
                },
                {
                    name: 'zg',
                    title: '最高',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td class="${data.f15 > data.f18 ? 'shares-rise' : (data.f15 < data.f18?'shares-fall':'') }">${self.numberFix(data.f15,data.f1)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f15'
                    }
                },
                {
                    name: 'zd',
                    title: '最低',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td class="${data.f16 > data.f18 ? 'shares-rise' : (data.f16 < data.f18?'shares-fall':'') }">${self.numberFix(data.f16,data.f1)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f16'
                    }
                }
            ]
        })
        quotetable.init().then(function(){
            if(location.search.indexOf('etf') > -1){
                if(navigator.userAgent.toLowerCase().indexOf('ipad') > -1 || navigator.userAgent.toLowerCase().indexOf('pad') > -1){
                    $(".hqlist-table .table-title").css('top','6.5rem')
                }else{
                    $(".hqlist-table .table-title").css('top','8rem')
                }
            } 
            if(location.search == '?mt=changneijijin_etf'){
                $("#etf-all-list").removeClass('hqlist-tab-item')
                $("#etf-all-list").addClass('hqlist-tab-item-active')
            }else if(location.search == '?mt=changneijijin_etf_hu'){
                $("#etf-hu-list").removeClass('hqlist-tab-item')
                $("#etf-hu-list").addClass('hqlist-tab-item-active')
            }else if(location.search == '?mt=changneijijin_etf_shen'){
                $("#etf-shen-list").removeClass('hqlist-tab-item')
                $("#etf-shen-list").addClass('hqlist-tab-item-active')
            }
        })
        return quotetable
    },
    makechangwaiTable: function(url) {
        let self = this
        let quotetable = new QuoteTable({
            ele: 'listtable',
            api: `${url}`,
            params: { // 默认参数配置
                sortkey: 'f3',
                sortval: '1',
                size: '20'
            },
            right_tds: 2,
            refresh: 15,
            sortdesc:'1',
            sortacr:'0',
            item: [
                {
                    name: 'name',
                    title: '名称',
                    html: function (data) {
                        if (data == null) {
                            return `<th>${this.title}</th>`
                        } else {
                            let icon = ''
                            if ((data.f13 == 1) && (data.f19 == 23)) {
                                icon = icon + "<span class='icon-kc'>科创</span>"
                            }
                            if ((data.f13 == 0) && (data.f111 & 2048)){
                                icon = icon + "<span class='icon-kc'>京</span>"
                            }
                            if (data.f148 & 64) {
                                icon = icon + "<span class='icon-rz'>融</span>"
                            }
                            return `<td><p>${data.f14}</p><p>${data.f12}${icon}</p></td>`
                        }
                    },
                    sort: false
                },
                {
                    name: 'zx',
                    title: '最新净值',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th value="true" class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td class="${data.f3 > 0 ? 'shares-rise' : (data.f3<0?'shares-fall':'') }">${self.numberFix(data.f2,data.f1)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f2'
                    }
                },
                {
                    name: 'zf',
                    title: '日涨幅',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_des">${this.title}</th>`
                        } else {
                            return `<td class="${data.f3 > 0 ? 'shares-rise' : (data.f3<0?'shares-fall':'') }">${self.dataProcess(data.f3,data.f152,'%')}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '0',
                        ascvalue: '1',
                        key: 'f3'
                    }
                }
            ]
        })
        quotetable.init()
        return quotetable
    },
    makechangwaihuobiTable: function(url) {
        let self = this
        let quotetable = new QuoteTable({
            ele: 'listtable',
            api: `${url}`,
            params: { // 默认参数配置
                sortkey: 'f3',
                sortval: '1',
                size: '20'
            },
            right_tds: 2,
            refresh: 15,
            sortdesc:'1',
            sortacr:'0',
            item: [
                {
                    name: 'name',
                    title: '名称',
                    html: function (data) {
                        if (data == null) {
                            return `<th>${this.title}</th>`
                        } else {
                            let icon = ''
                            if ((data.f13 == 1) && (data.f19 == 23)) {
                                icon = icon + "<span class='icon-kc'>科创</span>"
                            }
                            if ((data.f13 == 0) && (data.f111 & 2048)){
                                icon = icon + "<span class='icon-kc'>京</span>"
                            }
                            if (data.f148 & 64) {
                                icon = icon + "<span class='icon-rz'>融</span>"
                            }
                            return `<td><p>${data.f14}</p><p>${data.f12}${icon}</p></td>`
                        }
                    },
                    sort: false
                },
                {
                    name: 'zx',
                    title: '万份收益',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th value="true" class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td class="${data.f3 > 0 ? 'shares-rise' : (data.f3<0?'shares-fall':'') }">${self.numberFix(data.f2,data.f1)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f2'
                    }
                },
                {
                    name: 'zf',
                    title: '日涨幅',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_des">${this.title}</th>`
                        } else {
                            return `<td class="${data.f3 > 0 ? 'shares-rise' : (data.f3<0?'shares-fall':'') }">${self.dataProcess(data.f3,data.f152,'%')}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '0',
                        ascvalue: '1',
                        key: 'f3'
                    }
                }
            ]
        })
        quotetable.init()
        return quotetable
    },
    makezhaiquanTable: function(url) {
        let self = this
        let quotetable = new QuoteTable({
            ele: 'listtable',
            api: `${url}`,
            params: { // 默认参数配置
                sortkey: 'f3',
                sortval: '1',
                size: '20'
            },
            right_tds: 2,
            refresh: 15,
            sortdesc:'1',
            sortacr:'0',
            item: [
                {
                    name: 'name',
                    title: '名称',
                    html: function (data) {
                        if (data == null) {
                            return `<th>${this.title}</th>`
                        } else {
                            let icon = ''
                            if ((data.f13 == 1) && (data.f19 == 23)) {
                                icon = icon + "<span class='icon-kc'>科创</span>"
                            }
                            if (data.f148 & 64) {
                                icon = icon + "<span class='icon-rz'>融</span>"
                            }
                            return `<td><p>${data.f14}</p><p>${data.f12}${icon}</p></td>`
                        }
                    },
                    sort: false
                },
                {
                    name: 'zx',
                    title: '最新',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th value="true" class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td class="${data.f3 > 0 ? 'shares-rise' : (data.f3<0?'shares-fall':'') }">${self.numberFix(data.f2,data.f1)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f2'
                    }
                },
                {
                    name: 'zf',
                    title: '涨幅',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_des">${this.title}</th>`
                        } else {
                            return `<td class="${data.f3 > 0 ? 'shares-rise' : (data.f3<0?'shares-fall':'') }">${self.dataProcess(data.f3,data.f152,'%')}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '0',
                        ascvalue: '1',
                        key: 'f3'
                    }
                },
                {
                    name: 'zd',
                    title: '涨跌',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td class="${data.f4 > 0 ? 'shares-rise' : (data.f4<0?'shares-fall':'') }">${self.numberFix(data.f4,data.f1)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f4'
                    }
                },
                {
                    name: 'cjbs',
                    title: '成交笔数',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td>${self.conversion(data.f373,false,true,true)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f373'
                    }
                },
                {
                    name: 'cjl',
                    title: '成交量',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td>${self.conversion(data.f5,false,true,true)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f5'
                    }
                },
                {
                    name: 'cje',
                    title: '成交额',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td>${self.conversion(data.f6,false,true)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f6'
                    }
                },
                {
                    name: 'lb',
                    title: '量比',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td>${self.numberFix(data.f10,data.f152)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f10'
                    }
                },
                {
                    name: 'zs',
                    title: '昨收',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td>${self.numberFix(data.f18,data.f1)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f18'
                    }
                },
                {
                    name: 'jk',
                    title: '今开',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td>${self.numberFix(data.f17,data.f1)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f17'
                    }
                },
                {
                    name: 'zg',
                    title: '最高',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td class="${data.f15 > data.f18 ? 'shares-rise' : (data.f15 < data.f18?'shares-fall':'') }">${self.numberFix(data.f15,data.f1)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f15'
                    }
                },
                {
                    name: 'zd',
                    title: '最低',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td class="${data.f16 > data.f18 ? 'shares-rise' : (data.f16 < data.f18?'shares-fall':'') }">${self.numberFix(data.f16,data.f1)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f16'
                    }
                },
                {
                    name: 'jj',
                    title: '均价',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td>${self.numberFix(data.f352,data.f1)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f352'
                    }
                },
                {
                    name: 'zjcjfs',
                    title: '最近成交方式',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            var val = '-'
                            if(data.f414 == 1){
                                val = '匹配成交'
                            }
                            if(data.f414 == 2){
                                val = '协商成交'
                            }
                            if(data.f414 == 4){
                                val = '点击成交'
                            }
                            if(data.f414 == 8){
                                val = '意向申报'
                            }
                            if(data.f414 == 16){
                                val = '询价成交'
                            }
                            if(data.f414 == 32){
                                val = '竞买成交'
                            }
                            if(data.f414 == 64){
                                val = '匹配成交大额'
                            }
                            return `<td>${val}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f414'
                    }
                },
                {
                    name: 'sslx',
                    title: '所属类型',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            var val = '-'
                            if(data.f139 == 7){
                                val = '国债'
                            }
                            if(data.f139 == 8){
                                val = '地方债'
                            }
                            if(data.f139 == 9){
                                val = '企业债'
                            }
                            if(data.f139 == 10){
                                val = '公司债'
                            }
                            if(data.f139 == 11){
                                val = '可转债'
                            }
                            if(data.f139 == 12){
                                val = '可交换债'
                            }
                            if(data.f139 == 13){
                                val = '资产证券化'
                            }
                            if(data.f139 == 14){
                                val = '债权回购'
                            }
                            if(data.f139 == 15){
                                val = '其他债权'
                            }
                            return `<td>${val}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f139'
                    }
                }
            ]
        })
        quotetable.init()
        return quotetable
    },
    makeGlobalTipsTable: function(url) {
        let self = this
        let quotetable = new QuoteTable_Tips({
            ele: 'listtable',
            api: `${url}`,
            params: { // 默认参数配置
                sortkey: 'f487',
                sortval: '0',
                size: '20'
            },
            right_tds: 3,
            refresh: 15,
            sortdesc:'1',
            sortasc:'0',
            keyword: "globalTips",
            type:"allTips",
            item: [
                {
                  name: "name",
                  title: "名称",
                  html: function (data) {
                    if (data == null) {
                      return `<th>${this.title}</th>`
                    } else {
                      return `<td><p>${data.f14}</p><p>${data.f12}</p></td>`
                    }
                  },
                  sort: false,
                },
                {
                  name: "zx",
                  title: "最新",
                  html: function (data) {
                    if (data == null) {
                      return `<th value="true" class="sort_normal">${this.title}</th>`
                    } else {
                      return `<td class="${self.getTipsClassName(self.quote_color_reverse,data)}">${self.numberFix(data.f2, data.f1)}</td>`
                    }
                  },
                  sort: true,
                  sortitem: {
                    desvalue: "1",
                    ascvalue: "0",
                    key: "f2",
                  },
                },
                {
                  name: "zdf",
                  title: "涨幅",
                  html: function (data) {
                    if (data == null) {
                      return `<th class="sort_normal">${this.title}</th>`
                    } else {
                      return `<td class="${self.getTipsClassName(self.quote_color_reverse,data)}">${self.dataProcess(data.f3, data.f152, "%")}</td>`
                    }
                  },
                  sort: true,
                  sortitem: {
                    desvalue: "1",
                    ascvalue: "0",
                    key: "f3",
                  },
                },
                {
                  name: "zfe",
                  title: "涨跌",
                  html: function (data) {
                    if (data == null) {
                      return `<th class="sort_normal">${this.title}</th>`
                    } else {
                      return `<td class="${self.getTipsClassName(self.quote_color_reverse,data)}">${self.numberFix(data.f4, data.f1)}</td>`
                    }
                  },
                  sort: true,
                  sortitem: {
                    desvalue: "1",
                    ascvalue: "0",
                    key: "f4",
                  },
                },
                {
                  name: "buy",
                  title: "最优买",
                  html: function (data) {
                    if (data == null) {
                      return `<th class="sort_normal">${this.title}</th>`
                    } else {
                      return `<td class="${self.formatTipsCompareColor(self.quote_color_reverse,data.f31,data.f18)}">${self.numberFix(data.f31, data.f1)}</td>`
                    }
                  },
                  sort: true,
                  sortitem: {
                    desvalue: "1",
                    ascvalue: "0",
                    key: "f31",
                  },
                },
                {
                  name: "sell",
                  title: "最优卖",
                  html: function (data) {
                    if (data == null) {
                      return `<th class="sort_normal">${this.title}</th>`
                    } else {
                      return `<td class="${self.formatTipsCompareColor(self.quote_color_reverse,data.f32,data.f18)}">${self.numberFix(data.f32, data.f1)}</td>`
                    }
                  },
                  sort: true,
                  sortitem: {
                    desvalue: "1",
                    ascvalue: "0",
                    key: "f32",
                  },
                },
                {
                  name: "jk",
                  title: "今开",
                  html: function (data) {
                    if (data == null) {
                      return `<th class="sort_normal">${this.title}</th>`
                    } else {
                      return `<td class="${self.formatTipsCompareColor(self.quote_color_reverse,data.f17,data.f18)}">${self.numberFix(data.f17, data.f1)}</td>`
                    }
                  },
                  sort: true,
                  sortitem: {
                    desvalue: "1",
                    ascvalue: "0",
                    key: "f17",
                  },
                },
                {
                  name: "zg",
                  title: "最高",
                  html: function (data) {
                    if (data == null) {
                      return `<th class="sort_normal">${this.title}</th>`
                    } else {
                      return `<td class="${self.formatTipsCompareColor(self.quote_color_reverse,data.f15,data.f18)}">${self.numberFix(data.f15, data.f1)}</td>`
                    }
                  },
                  sort: true,
                  sortitem: {
                    desvalue: "1",
                    ascvalue: "0",
                    key: "f15",
                  },
                },
                {
                  name: "zd",
                  title: "最低",
                  html: function (data) {
                    if (data == null) {
                      return `<th class="sort_normal">${this.title}</th>`
                    } else {
                      return `<td class="${self.formatTipsCompareColor(self.quote_color_reverse,data.f16,data.f18)}">${self.numberFix(data.f16, data.f1)}</td>`
                    }
                  },
                  sort: true,
                  sortitem: {
                    desvalue: "1",
                    ascvalue: "0",
                    key: "f16",
                  },
                },
                {
                  name: "zs",
                  title: "昨收",
                  html: function (data) {
                    if (data == null) {
                      return `<th class="sort_normal">${this.title}</th>`
                    } else {
                      return `<td>${self.numberFix(data.f18, data.f1)}</td>`
                    }
                  },
                  sort: true,
                  sortitem: {
                    desvalue: "1",
                    ascvalue: "0",
                    key: "f18",
                  },
                },
                {
                  name: "update",
                  title: "更新时间",
                  html: function (data) {
                    if (data == null) {
                      return `<th class="sort_normal">${this.title}</th>`
                    } else {
                      return `<td>${self.formatDate(data.f124*1000,"hh:mm:ss")}</td>`
                    }
                  },
                  sort: true,
                  sortitem: {
                    desvalue: "1",
                    ascvalue: "0",
                    key: "f124",
                  },
                },
                {
                  name: "country",
                  title: "国家/地区",
                  html: function (data) {
                    if (data == null) {
                      return `<th class="sort_normal">${this.title}</th>`
                    } else {
                      return `<td>${data.f492??"-"}</td>`
                    }
                  },
                  sort: true,
                  sortitem: {
                    desvalue: "1",
                    ascvalue: "0",
                    key: "f492",
                  },
                },
                {
                  name: "year",
                  title: "期限",
                  html: function (data) {
                    if (data == null) {
                      return `<th class="sort_normal">${this.title}</th>`
                    } else {
                      return `<td>${data.f487}</td>`
                    }
                  },
                  sort: true,
                  sortitem: {
                    desvalue: "1",
                    ascvalue: "0",
                    key: "f487",
                  },
                },
                {
                    name: "currency",
                    title: "货币",
                    html: function (data) {
                      if (data == null) {
                        return `<th class="sort_normal">${this.title}</th>`
                      } else {
                        return `<td>${data.f495}</td>`
                      }
                    },
                    sort: true,
                    sortitem: {
                      desvalue: "1",
                      ascvalue: "0",
                      key: "f495",
                    },
                  },
              ],
        })
        quotetable.init(true).then(function(e){
            if(location.search.indexOf('globaltips') > -1){
                if(navigator.userAgent.toLowerCase().indexOf('pad') > -1 || navigator.userAgent.toLowerCase().indexOf('surface') > -1){
                    $(".hqlist-table .table-title").css('top','9.5rem')
                }else{
                    $(".hqlist-table .table-title").css('top','10.5rem')
                }
                $(".title_left table tr th").addClass("thead-left")
            }
            if(e == undefined || e.data == null){
                $("#list-loadmore").html('暂无数据')
            }
        })
        return quotetable
    },
    makeUSTipsTable: function(url) {
        let self = this
        let quotetable = new QuoteTable_Tips({
            ele: 'listtable',
            api: `${url}`,
            params: { // 默认参数配置
                sortkey: 'f487',
                sortval: '0',
                size: '20'
            },
            right_tds: 3,
            refresh: 15,
            sortdesc:'1',
            sortasc:'0',
            keyword: "tips",
            type:"allTips",
            item: [
                {
                  name: "name",
                  title: "名称",
                  html: function (data) {
                    if (data == null) {
                      return `<th>${this.title}</th>`
                    } else {
                      return `<td><p>${data.f14}</p><p>${data.f12}</p></td>`
                    }
                  },
                  sort: false,
                },
                {
                  name: "zx",
                  title: "最新",
                  html: function (data) {
                    if (data == null) {
                      return `<th value="true" class="sort_normal">${this.title}</th>`
                    } else {
                      return `<td class="${self.getTipsClassName(self.quote_color_reverse,data)}">${self.numberFix(data.f2, data.f1)}</td>`
                    }
                  },
                  sort: true,
                  sortitem: {
                    desvalue: "1",
                    ascvalue: "0",
                    key: "f2",
                  },
                },
                {
                  name: "zdf",
                  title: "涨幅",
                  html: function (data) {
                    if (data == null) {
                      return `<th class="sort_normal">${this.title}</th>`
                    } else {
                      return `<td class="${self.getTipsClassName(self.quote_color_reverse,data)}">${self.dataProcess(data.f3, data.f152, "%")}</td>`
                    }
                  },
                  sort: true,
                  sortitem: {
                    desvalue: "0",
                    ascvalue: "1",
                    key: "f3",
                  },
                },
                {
                  name: "zfe",
                  title: "涨跌",
                  html: function (data) {
                    if (data == null) {
                      return `<th class="sort_normal">${this.title}</th>`
                    } else {
                      return `<td class="${self.getTipsClassName(self.quote_color_reverse,data)}">${self.numberFix(data.f4, data.f1)}</td>`
                    }
                  },
                  sort: true,
                  sortitem: {
                    desvalue: "0",
                    ascvalue: "1",
                    key: "f4",
                  },
                },
                {
                  name: "buy",
                  title: "最优买",
                  html: function (data) {
                    if (data == null) {
                      return `<th class="sort_normal">${this.title}</th>`
                    } else {
                      return `<td class="${self.formatTipsCompareColor(self.quote_color_reverse,data.f31,data.f18)}">${self.numberFix(data.f31, data.f1)}</td>`
                    }
                  },
                  sort: true,
                  sortitem: {
                    desvalue: "1",
                    ascvalue: "0",
                    key: "f31",
                  },
                },
                {
                  name: "sell",
                  title: "最优卖",
                  html: function (data) {
                    if (data == null) {
                      return `<th class="sort_normal">${this.title}</th>`
                    } else {
                      return `<td class="${self.formatTipsCompareColor(self.quote_color_reverse,data.f32,data.f18)}">${self.numberFix(data.f32, data.f1)}</td>`
                    }
                  },
                  sort: true,
                  sortitem: {
                    desvalue: "1",
                    ascvalue: "0",
                    key: "f32",
                  },
                },
                {
                  name: "jk",
                  title: "今开",
                  html: function (data) {
                    if (data == null) {
                      return `<th class="sort_normal">${this.title}</th>`
                    } else {
                      return `<td class="${self.formatTipsCompareColor(self.quote_color_reverse,data.f17,data.f18)}">${self.numberFix(data.f17, data.f1)}</td>`
                    }
                  },
                  sort: true,
                  sortitem: {
                    desvalue: "1",
                    ascvalue: "0",
                    key: "f17",
                  },
                },
                {
                  name: "zg",
                  title: "最高",
                  html: function (data) {
                    if (data == null) {
                      return `<th class="sort_normal">${this.title}</th>`
                    } else {
                      return `<td class="${self.formatTipsCompareColor(self.quote_color_reverse,data.f15,data.f18)}">${self.numberFix(data.f15, data.f1)}</td>`
                    }
                  },
                  sort: true,
                  sortitem: {
                    desvalue: "1",
                    ascvalue: "0",
                    key: "f15",
                  },
                },
                {
                  name: "zd",
                  title: "最低",
                  html: function (data) {
                    if (data == null) {
                      return `<th class="sort_normal">${this.title}</th>`
                    } else {
                      return `<td class="${self.formatTipsCompareColor(self.quote_color_reverse,data.f16,data.f18)}">${self.numberFix(data.f16, data.f1)}</td>`
                    }
                  },
                  sort: true,
                  sortitem: {
                    desvalue: "1",
                    ascvalue: "0",
                    key: "f16",
                  },
                },
                {
                  name: "zs",
                  title: "昨收",
                  html: function (data) {
                    if (data == null) {
                      return `<th class="sort_normal">${this.title}</th>`
                    } else {
                      return `<td>${self.numberFix(data.f18, data.f1)}</td>`
                    }
                  },
                  sort: true,
                  sortitem: {
                    desvalue: "1",
                    ascvalue: "0",
                    key: "f18",
                  },
                },
                {
                  name: "update",
                  title: "更新时间",
                  html: function (data) {
                    if (data == null) {
                      return `<th class="sort_normal">${this.title}</th>`
                    } else {
                      return `<td>${self.formatDate(data.f124*1000,"hh:mm:ss")}</td>`
                    }
                  },
                  sort: true,
                  sortitem: {
                    desvalue: "1",
                    ascvalue: "0",
                    key: "f124",
                  },
                },
                {
                  name: "country",
                  title: "国家/地区",
                  html: function (data) {
                    if (data == null) {
                      return `<th class="sort_normal">${this.title}</th>`
                    } else {
                      return `<td>${data.f492??"-"}</td>`
                    }
                  },
                  sort: true,
                  sortitem: {
                    desvalue: "1",
                    ascvalue: "0",
                    key: "f492",
                  },
                },
                {
                  name: "year",
                  title: "期限",
                  html: function (data) {
                    if (data == null) {
                      return `<th class="sort_normal">${this.title}</th>`
                    } else {
                      return `<td>${data.f487}</td>`
                    }
                  },
                  sort: true,
                  sortitem: {
                    desvalue: "1",
                    ascvalue: "0",
                    key: "f487",
                  },
                },
              ],
        })
        quotetable.init()
        return quotetable
    },
    makeGlobalBondTable: function(url) {
        let self = this
        let quotetable = new QuoteTable_Tips({
            ele: 'listtable',
            api: `${url}`,
            params: { // 默认参数配置
                sortkey: 'f488',
                sortval: '0',
                size: '20'
            },
            right_tds: 3,
            refresh: 15,
            sortdesc:'1',
            sortasc:'0',
            keyword: "globalbond",
            item: [
                {
                  name: "name",
                  title: "名称",
                  html: function (data) {
                    if (data == null) {
                      return `<th>${this.title}</th>`
                    } else {
                      return `<td><p>${data.f14}</p><p>${data.f12}</p></td>`
                    }
                  },
                  sort: false,
                },
                {
                  name: "year",
                  title: "剩余期限",
                  html: function (data) {
                    if (data == null) {
                      return `<th class="sort_normal">${this.title}</th>`
                    } else {
                      return `<td>${data.f488}</td>`
                    }
                  },
                  sort: true,
                  sortitem: {
                    desvalue: "1",
                    ascvalue: "0",
                    key: "f488",
                  },
                },
                {
                  name: "zx",
                  title: "最新",
                  html: function (data) {
                    if (data == null) {
                      return `<th value="true" class="sort_normal">${this.title}</th>`
                    } else {
                      return `<td class="${data.f4 > 0 ? "shares-rise" : data.f4 < 0 ? "shares-fall" : ""}">${self.numberFix(data.f2, data.f1)}</td>`
                    }
                  },
                  sort: true,
                  sortitem: {
                    desvalue: "1",
                    ascvalue: "0",
                    key: "f2",
                  },
                },
                {
                  name: "zdf",
                  title: "涨跌幅",
                  html: function (data) {
                    if (data == null) {
                      return `<th class="sort_normal">${this.title}</th>`
                    } else {
                      return `<td class="${data.f4 > 0 ? "shares-rise" : data.f4 < 0 ? "shares-fall" : ""}">${self.dataProcess(data.f3, data.f152, "%")}</td>`
                    }
                  },
                  sort: true,
                  sortitem: {
                    desvalue: "1",
                    ascvalue: "0",
                    key: "f3",
                  },
                },
                {
                  name: "zfe",
                  title: "涨跌",
                  html: function (data) {
                    if (data == null) {
                      return `<th class="sort_normal">${this.title}</th>`
                    } else {
                      return `<td class="${data.f4 > 0 ? "shares-rise" : data.f4 < 0 ? "shares-fall" : ""}">${self.numberFix(data.f4, data.f1)}</td>`
                    }
                  },
                  sort: true,
                  sortitem: {
                    desvalue: "1",
                    ascvalue: "0",
                    key: "f4",
                  },
                },
                {
                  name: "ytm",
                  title: "最新YTM",
                  html: function (data) {
                    if (data == null) {
                      return `<th class="sort_normal">${this.title}</th>`
                    } else {
                      return `<td class="${data.f497 == 1?(data.f4 > 0 ? "shares-rise" : data.f4 < 0 ? "shares-fall" : ""):(data.f4 < 0 ? "shares-rise" : data.f4 > 0 ? "shares-fall" : "")}">${self.numberFix(data.f350, data.f1)}</td>`
                    }
                  },
                  sort: true,
                  sortitem: {
                    desvalue: "1",
                    ascvalue: "0",
                    key: "f350",
                  },
                },
                {
                  name: "enddate",
                  title: "到期日期",
                  html: function (data) {
                    if (data == null) {
                      return `<th class="sort_normal">${this.title}</th>`
                    } else {
                      return `<td>${self.formatDate(data.f491*1000,"yyyy-MM-dd")}</td>`
                    }
                  },
                  sort: true,
                  sortitem: {
                    desvalue: "1",
                    ascvalue: "0",
                    key: "f491",
                  },
                },
                {
                  name: "buy",
                  title: "最优买",
                  html: function (data) {
                    if (data == null) {
                      return `<th class="sort_normal">${this.title}</th>`
                    } else {
                      return `<td class="${self.formatCompareColor(data.f31,data.f18)}">${self.numberFix(data.f31, data.f1)}</td>`
                    }
                  },
                  sort: true,
                  sortitem: {
                    desvalue: "1",
                    ascvalue: "0",
                    key: "f31",
                  },
                },
                {
                  name: "buy_ytm",
                  title: "最优买YTM",
                  html: function (data) {
                    if (data == null) {
                      return `<th class="sort_normal">${this.title}</th>`
                    } else {
                      return `<td class="${data.f497 == 1?self.formatCompareColor(data.f31,data.f18):self.formatCompareColor(data.f18,data.f31)}">${self.formatUniqueNumToFixed(data.f499, 0, data.f1)}</td>`
                    }
                  },
                  sort: true,
                  sortitem: {
                    desvalue: "1",
                    ascvalue: "0",
                    key: "f499",
                  },
                },
                {
                  name: "sell",
                  title: "最优卖",
                  html: function (data) {
                    if (data == null) {
                      return `<th class="sort_normal">${this.title}</th>`
                    } else {
                      return `<td class="${self.formatCompareColor(data.f32,data.f18)}">${self.numberFix(data.f32, data.f1)}</td>`
                    }
                  },
                  sort: true,
                  sortitem: {
                    desvalue: "1",
                    ascvalue: "0",
                    key: "f32",
                  },
                },
                {
                  name: "sell_ytm",
                  title: "最优卖YTM",
                  html: function (data) {
                    if (data == null) {
                      return `<th class="sort_normal">${this.title}</th>`
                    } else {
                      return `<td class="${data.f497 == 1?self.formatCompareColor(data.f32,data.f18):self.formatCompareColor(data.f18,data.f32)} ">${self.formatUniqueNumToFixed(data.f498, 0, data.f1)}</td>`
                    }
                  },
                  sort: true,
                  sortitem: {
                    desvalue: "1",
                    ascvalue: "0",
                    key: "f498",
                  },
                },
                {
                  name: "jk",
                  title: "今开",
                  html: function (data) {
                    if (data == null) {
                      return `<th class="sort_normal">${this.title}</th>`
                    } else {
                      return `<td class="${self.formatCompareColor(data.f17,data.f18)}">${self.numberFix(data.f17, data.f1)}</td>`
                    }
                  },
                  sort: true,
                  sortitem: {
                    desvalue: "1",
                    ascvalue: "0",
                    key: "f17",
                  },
                },
                {
                  name: "zg",
                  title: "最高",
                  html: function (data) {
                    if (data == null) {
                      return `<th class="sort_normal">${this.title}</th>`
                    } else {
                      return `<td class="${self.formatCompareColor(data.f15,data.f18)}">${self.numberFix(data.f15, data.f1)}</td>`
                    }
                  },
                  sort: true,
                  sortitem: {
                    desvalue: "1",
                    ascvalue: "0",
                    key: "f15",
                  },
                },
                {
                  name: "zd",
                  title: "最低",
                  html: function (data) {
                    if (data == null) {
                      return `<th class="sort_normal">${this.title}</th>`
                    } else {
                      return `<td class="${self.formatCompareColor(data.f16,data.f18)}">${self.numberFix(data.f16, data.f1)}</td>`
                    }
                  },
                  sort: true,
                  sortitem: {
                    desvalue: "1",
                    ascvalue: "0",
                    key: "f16",
                  },
                },
                {
                  name: "zs",
                  title: "昨收",
                  html: function (data) {
                    if (data == null) {
                      return `<th class="sort_normal">${this.title}</th>`
                    } else {
                      return `<td>${self.numberFix(data.f18, data.f1)}</td>`
                    }
                  },
                  sort: true,
                  sortitem: {
                    desvalue: "1",
                    ascvalue: "0",
                    key: "f18",
                  },
                },
                {
                  name: "update",
                  title: "更新时间",
                  html: function (data) {
                    if (data == null) {
                      return `<th class="sort_normal">${this.title}</th>`
                    } else {
                      return `<td>${self.formatDate(data.f124*1000,"hh:mm:ss")}</td>`
                    }
                  },
                  sort: true,
                  sortitem: {
                    desvalue: "1",
                    ascvalue: "0",
                    key: "f124",
                  },
                },
                {
                  name: "country",
                  title: "国家/地区",
                  html: function (data) {
                    if (data == null) {
                      return `<th class="sort_normal">${this.title}</th>`
                    } else {
                      return `<td>${data.f492??"-"}</td>`
                    }
                  },
                  sort: true,
                  sortitem: {
                    desvalue: "1",
                    ascvalue: "0",
                    key: "f492",
                  },
                },
                {
                  name: "currency",
                  title: "货币",
                  html: function (data) {
                    if (data == null) {
                      return `<th class="sort_normal">${this.title}</th>`
                    } else {
                      return `<td>${data.f495}</td>`
                    }
                  },
                  sort: true,
                  sortitem: {
                    desvalue: "1",
                    ascvalue: "0",
                    key: "f495",
                  },
                },
              ],
        })
        $("#list-loadmore").addClass("global-bond-stockmore")
        quotetable.init(true).then(function(e){
            if(e == undefined || e.data == null){
                $("#list-loadmore").html('暂无数据')
            }
        })
        return quotetable
    },
    makeUSPreReleaseTable: function(url) {
        let self = this
        let quotetable = new QuoteTable_Tips({
            ele: 'listtable',
            api: `${url}`,
            params: { // 默认参数配置
                // sortkey: 'f3',
                sortval: '1',
                size: '20'
            },
            right_tds: 2,
            refresh: 15,
            sortdesc:'1',
            sortasc:'0',
            item: [
                {
                  name: "name",
                  title: "名称",
                  html: function (data) {
                    if (data == null) {
                      return `<th>${this.title}</th>`
                    } else {
                      return `<td><p>${data.f14}</p><p>${data.f12}</p></td>`
                    }
                  },
                  sort: false,
                },
                {
                  name: "saledate",
                  title: "拍卖日期",
                  html: function (data) {
                    if (data == null) {
                      return `<th class="sort_normal">${this.title}</th>`
                    } else {
                      return `<td>${self.formatDate(data.f489*1000,"yyyy-MM-dd")}</td>`
                    }
                  },
                  sort: true,
                  sortitem: {
                    desvalue: "1",
                    ascvalue: "0",
                    key: "f489",
                  },
                },
                {
                  name: "releasedate",
                  title: "发行日期",
                  html: function (data) {
                    if (data == null) {
                      return `<th class="sort_normal">${this.title}</th>`
                    } else {
                      return `<td>${self.formatDate(data.f490*1000,"yyyy-MM-dd")}</td>`
                    }
                  },
                  sort: true,
                  sortitem: {
                    desvalue: "1",
                    ascvalue: "0",
                    key: "f490",
                  },
                },
                {
                  name: "enddate",
                  title: "到期日期",
                  html: function (data) {
                    if (data == null) {
                      return `<th class="sort_normal">${this.title}</th>`
                    } else {
                      return `<td>${self.formatDate(data.f491*1000,"yyyy-MM-dd")}</td>`
                    }
                  },
                  sort: true,
                  sortitem: {
                    desvalue: "1",
                    ascvalue: "0",
                    key: "f491",
                  },
                },
              ],
        })
        $("#list-loadmore").addClass("global-bond-stockmore")
        quotetable.init(true).then(function(e){
            if(e == undefined || e.data == null){
                $("#list-loadmore").html('暂无数据')
            }
        })
        return quotetable
    },
    makeUSFuturesTable: function (url) {
        let self = this
        let quotetable = new QuoteTable({
            ele: 'listtable',
            api: url,
            params: {
                // sortkey: 'f487',
                sortval: '0',
                size: '20'
            },
            right_tds: 3,
            refresh: 15,
            sortdesc:'1',
            sortasc:'0',
            dataProcess:function(data){
                return data.list
            },
            item: [
                {
                    name: 'name',
                    title: '名称',
                    html: function (data) {
                        if (data == null) {
                            return `<th>${this.title}</th>`
                        } else {
                            return `<td><p>${data.f14}</p><p>${data.f12}</p></td>`
                        }
                    },
                    sort: false
                },
                {
                    name: 'zx',
                    title: '最新',
                    html: function (data) {
                        if (data == null) {
                            return `<th value="true" class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td class="${data.f4 > 0 ? "shares-rise" : data.f4 < 0 ? "shares-fall" : ""}">${self.numberFix(data.f2, data.f1)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f2'
                    }
                },
                {
                    name: 'zf',
                    title: '涨幅',
                    html: function (data) {
                        if (data == null) {
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td class="${data.f4 > 0 ? "shares-rise" : data.f4 < 0 ? "shares-fall" : ""}">${self.dataProcess(data.f3, data.f152, "%")}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f3'
                    }
                },
                {
                    name: 'zde',
                    title: '涨跌',
                    html: function (data) {
                        if (data == null) {
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td class="${data.f4 > 0 ? "shares-rise" : data.f4 < 0 ? "shares-fall" : ""}">${self.numberFix(data.f4, data.f1)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f4'
                    }
                },
                {
                    name: 'zl',
                    title: '总手',
                    html: function (data) {
                        if (data == null) {
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td>${self.conversion(data.f5,false,true,true)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f5'
                    }
                },
                {
                    name: 'ccl',
                    title: '持仓量',
                    html: function (data) {
                        if (data == null) {
                            return `<th class="sort_des">${this.title}</th>`
                        } else {
                            return `<td>${self.conversion(data.f108,false,true)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f108'
                    }
                },
                {
                    name: 'rzc',
                    title: '日增仓',
                    html: function (data) {
                        if (data == null) {
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td class="${data.f163 > 0 ? 'shares-rise' : (data.f163 < 0?'shares-fall':'') }">${self.conversion(data.f163,true,true)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f163'
                    }
                },
                {
                    name: 'buy',
                    title: '买入',
                    html: function (data) {
                        if (data == null) {
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td class="${self.formatCompareColor(data.f31,data.f18)}">${self.numberFix(data.f31, data.f1)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f31'
                    }
                },
                {
                    name: 'sell',
                    title: '卖出',
                    html: function (data) {
                        if (data == null) {
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td class="${self.formatCompareColor(data.f32,data.f18)}">${self.numberFix(data.f32, data.f1)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f32'
                    }
                },
                {
                    name: 'je',
                    title: '金额',
                    html: function (data) {
                        if (data == null) {
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td>${self.conversion(data.f6,false,true)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f6'
                    }
                },
                {
                    name: 'kp',
                    title: '开盘',
                    html: function (data) {
                        if (data == null) {
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td class="${self.formatCompareColor(data.f17,data.f18)}">${self.numberFix(data.f17, data.f1)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f17'
                    }
                },
                {
                    name: 'zg',
                    title: '最高',
                    html: function (data) {
                        if (data == null) {
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td class="${self.formatCompareColor(data.f15,data.f18)}">${self.numberFix(data.f15, data.f1)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f15'
                    }
                },
                {
                    name: 'zd',
                    title: '最低',
                    html: function (data) {
                        if (data == null) {
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td class="${self.formatCompareColor(data.f16,data.f18)}">${self.numberFix(data.f16, data.f1)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f16'
                    }
                },
                {
                    name: 'zf',
                    title: '振幅',
                    html: function (data) {
                        if (data == null) {
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td>${self.dataProcess(data.f7,data.f152,'%')}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f7'
                    }
                },
                {
                    name: 'zjs',
                    title: '昨结算',
                    html: function (data) {
                        if (data == null) {
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td>${self.numberFix(data.f28, data.f1)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f28'
                    }
                }
            ]
        })
        let data = quotetable.init(true)
        data.then(function(e){
            if(e == undefined || e.list == null){
                $(".hsphb-more").html('暂无数据')
            }else{
                if(e.list.length < self.pz_size || e.list.length == e.total){
                    $(".hsphb-more").html('已经到底了')
                }else{
                    $(".hsphb-more").html('查看更多<i class="arrow-down"></i>')
                }
            }
        })
        return quotetable
    },
    makechangzhaiquanTable: function(url) {
        let self = this
        let quotetable = new QuoteTable({
            ele: 'listtable',
            api: `${url}`,
            params: { // 默认参数配置
                sortkey: 'f3',
                sortval: '1',
                size: '20'
            },
            right_tds: 3,
            refresh: 15,
            sortdesc:'1',
            sortacr:'0',
            item: [
                {
                    name: 'name',
                    title: '名称',
                    html: function (data) {
                        if (data == null) {
                            return `<th>${this.title}</th>`
                        } else {
                            let icon = ''
                            if ((data.f13 == 1) && (data.f19 == 23)) {
                                icon = icon + "<span class='icon-kc'>科创</span>"
                            }
                            if ((data.f13 == 0) && (data.f111 & 2048)){
                                icon = icon + "<span class='icon-kc'>京</span>"
                            }
                            if (data.f148 & 64) {
                                icon = icon + "<span class='icon-rz'>融</span>"
                            }
                            return `<td><p>${data.f14}</p><p>${data.f12}${icon}</p></td>`
                        }
                    },
                    sort: false
                },
                {
                    name: 'zx',
                    title: '最新',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th value="true" class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td class="${data.f3 > 0 ? 'shares-rise' : (data.f3<0?'shares-fall':'') }">${self.numberFix(data.f2,data.f1)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f2'
                    }
                },
                {
                    name: 'zf',
                    title: '涨幅',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_des">${this.title}</th>`
                        } else {
                            return `<td class="${data.f3 > 0 ? 'shares-rise' : (data.f3<0?'shares-fall':'') }">${self.dataProcess(data.f3,data.f152,'%')}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '0',
                        ascvalue: '1',
                        key: 'f3'
                    }
                },
                {
                    name: 'zd',
                    title: '涨跌',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td class="${data.f4 > 0 ? 'shares-rise' : (data.f4<0?'shares-fall':'') }">${self.numberFix(data.f4,data.f1)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f4'
                    }
                },
                {
                    name: 'zl',
                    title: '总手',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td>${self.conversion(data.f5,false,true,true)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f5'
                    }
                },
                {
                    name: 'je',
                    title: '金额',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td>${self.conversion(data.f6,false,true)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f6'
                    }
                },
                {
                    name: 'lb',
                    title: '量比',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td>${self.numberFix(data.f10,data.f152)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f10'
                    }
                }
            ]
        })
        quotetable.init()
        return quotetable
    },
    makechangzhaiquanhuigouTable: function(url) {
        let self = this
        let quotetable = new QuoteTable({
            ele: 'listtable',
            api: `${url}`,
            params: { // 默认参数配置
                sortkey: 'f2',
                sortval: '1',
                size: '20'
            },
            right_tds: 2,
            refresh: 15,
            sortdesc:'1',
            sortacr:'0',
            item: [
                {
                    name: 'name',
                    title: '名称',
                    html: function (data) {
                        if (data == null) {
                            return `<th>${this.title}</th>`
                        } else {
                            let icon = ''
                            if ((data.f13 == 1) && (data.f19 == 23)) {
                                icon = icon + "<span class='icon-kc'>科创</span>"
                            }
                            if ((data.f13 == 0) && (data.f111 & 2048)){
                                icon = icon + "<span class='icon-kc'>京</span>"
                            }
                            if (data.f148 & 64) {
                                icon = icon + "<span class='icon-rz'>融</span>"
                            }
                            return `<td><p>${data.f14}</p><p>${data.f12}${icon}</p></td>`
                        }
                    },
                    sort: false
                },
                {
                    name: 'zx',
                    title: '最新',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th value="true" class="sort_des">${this.title}</th>`
                        } else {
                            return `<td class="${data.f3 > 0 ? 'shares-rise' : (data.f3<0?'shares-fall':'') }">${self.numberFix(data.f2,data.f1)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f2'
                    }
                },
                {
                    name: 'wysy',
                    title: '万元收益',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th value="true" class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td class="${data.f247 > 0 ? 'shares-rise' : (data.f247<0?'shares-fall':'') }">${self.numberFix(data.f247/10,3)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f247'
                    }
                },
                {
                    name: 'zjkyr',
                    title: '资金可用日',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th value="true" class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td>${self.dateTrans(data.f416)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f416'
                    }
                },
                {
                    name: 'zjkqr',
                    title: '资金可取日',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th value="true" class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td>${self.dateTrans(data.f417)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f417'
                    }
                },
                {
                    name: 'zkts',
                    title: '占款天数',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td>${data.f248}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '0',
                        ascvalue: '1',
                        key: 'f248'
                    }
                },
                {
                    name: 'jyts',
                    title: '借用天数',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td>${data.f418 ? data.f418 : '-'}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '0',
                        ascvalue: '1',
                        key: 'f418'
                    }
                },
                {
                    name: 'zf',
                    title: '涨幅',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td class="${data.f3 > 0 ? 'shares-rise' : (data.f3<0?'shares-fall':'') }">${self.dataProcess(data.f3,data.f152,'%')}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '0',
                        ascvalue: '1',
                        key: 'f3'
                    }
                },
                {
                    name: 'zd',
                    title: '涨跌',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td class="${data.f4 > 0 ? 'shares-rise' : (data.f4<0?'shares-fall':'') }">${self.numberFix(data.f4,data.f1)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f4'
                    }
                },
                {
                    name: 'cjbs',
                    title: '成交笔数',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td>${self.conversion(data.f373,false,true,true)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f373'
                    }
                },
                {
                    name: 'zl',
                    title: '成交量',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td>${self.conversion(data.f5,false,true,true)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f5'
                    }
                },
                {
                    name: 'je',
                    title: '成交额',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td>${self.conversion(data.f6,false,true)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f6'
                    }
                },
                {
                    name: 'lb',
                    title: '量比',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td>${self.numberFix(data.f10,data.f152)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f10'
                    }
                },
                {
                    name: 'zs',
                    title: '昨收',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td>${self.numberFix(data.f18,data.f1)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f18'
                    }
                },
                {
                    name: 'jk',
                    title: '今开',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td>${self.numberFix(data.f17,data.f1)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f17'
                    }
                },
                {
                    name: 'zg',
                    title: '最高',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td class="${data.f15 > data.f18 ? 'shares-rise' : (data.f15 < data.f18?'shares-fall':'') }">${self.numberFix(data.f15,data.f1)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f15'
                    }
                },
                {
                    name: 'zd',
                    title: '最低',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td class="${data.f16 > data.f18 ? 'shares-rise' : (data.f16 < data.f18?'shares-fall':'') }">${self.numberFix(data.f16,data.f1)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f16'
                    }
                },
                {
                    name: 'jj',
                    title: '均价',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td>${self.numberFix(data.f352,data.f1)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f352'
                    }
                }
            ]
        })
        quotetable.init()
        return quotetable
    },
    isAutoRefresh: function () {
        let self = this
        let isCN = checkIP()
        if(self.is_ganggutong_fund){
            if(isCN){
                if(getCookie("uidal") != null && getCookie("uidal") != undefined && getCookie("uidal") != ""){
                    return true
                }else{
                    return false
                }
            }else{
                return false
            }
        }else{
            return true
        }
    },
    makehushengangtongTable: function(url) {
        let self = this
        let quotetable = new QuoteTable({
            ele: 'listtable',
            api: `${url}`,
            params: { // 默认参数配置
                sortkey: 'f3',
                sortval: '1',
                size: '20'
            },
            right_tds: 3,
            refresh: self.isAutoRefresh() ? 15 : 0,
            sortdesc:'1',
            sortacr:'0',
            item: [
                {
                    name: 'name',
                    title: '名称',
                    html: function (data) {
                        if (data == null) {
                            return `<th>${this.title}</th>`
                        } else {
                            let icon = ''
                            if ((data.f13 == 1) && (data.f19 == 23)) {
                                icon = icon + "<span class='icon-kc'>科创</span>"
                            }
                            if ((data.f13 == 0) && (data.f111 & 2048)){
                                icon = icon + "<span class='icon-kc'>京</span>"
                            }
                            if (data.f148 & 64) {
                                icon = icon + "<span class='icon-rz'>融</span>"
                            }
                            return `<td><p>${data.f14}</p><p>${data.f12}${icon}</p></td>`
                        }
                    },
                    sort: false
                },
                {
                    name: 'zx',
                    title: '最新',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th value="true" class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td class="${data.f3 > 0 ? 'shares-rise' : (data.f3<0?'shares-fall':'') }">${self.numberFix(data.f2,data.f1)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f2'
                    }
                },
                {
                    name: 'zf',
                    title: '涨幅',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_des">${this.title}</th>`
                        } else {
                            return `<td class="${data.f3 > 0 ? 'shares-rise' : (data.f3<0?'shares-fall':'') }">${self.dataProcess(data.f3,data.f152,'%')}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '0',
                        ascvalue: '1',
                        key: 'f3'
                    }
                },
                {
                    name: 'zd',
                    title: '涨跌',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td class="${data.f4 > 0 ? 'shares-rise' : (data.f4<0?'shares-fall':'') }">${self.numberFix(data.f4,data.f1)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f4'
                    }
                },
                {
                    name: 'zl',
                    title: '总手',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td>${self.conversion(data.f5,false,true,true)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f5'
                    }
                },
                {
                    name: 'je',
                    title: '金额',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td>${self.conversion(data.f6,false,true)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f6'
                    }
                },
                {
                    name: 'zg',
                    title: '最高',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td class="${data.f15 > data.f18 ? 'shares-rise' : (data.f15 < data.f18?'shares-fall':'') }">${self.numberFix(data.f15,data.f1)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f15'
                    }
                },
                {
                    name: 'zd',
                    title: '最低',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td class="${data.f16 > data.f18 ? 'shares-rise' : (data.f16 < data.f18?'shares-fall':'') }">${self.numberFix(data.f16,data.f1)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f16'
                    }
                },
                {
                    name: 'hs',
                    title: '换手',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td>${self.dataProcess(data.f8,data.f152,'%')}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f8'
                    }
                },
                {
                    name: 'syl',
                    title: '市盈',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td>${self.numberFix(data.f9,data.f152)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f9'
                    }
                },
                {
                    name: 'zsz',
                    title: '总市值',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td>${ self.conversion(data.f20,false,true)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f20'
                    }
                },{
                    name: 'ltsz',
                    title: '流通市值',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td>${ self.conversion(data.f21,false,true)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f21'
                    }
                }
            ]
        })
        quotetable.init().then(function(){
            if(navigator.userAgent.toLowerCase().indexOf('ipad') > -1 || navigator.userAgent.toLowerCase().indexOf('pad') > -1){
                $(".hqlist-table .table-title").css('top','6.5rem')
            }else{
                $(".hqlist-table .table-title").css('top','8rem')
            }
            let singleStocks = ['?mt=hushengangtong_hugutong','?mt=hushengangtong_shengutong','?mt=hushengangtong_ganggutonghu','?mt=hushengangtong_ganggutongshen']
            let singleFunds = ['?mt=hushengangtong_hugutong_fund','?mt=hushengangtong_shengutong_fund','?mt=hushengangtong_ganggutonghu_fund','?mt=hushengangtong_ganggutongshen_fund']
            if(singleStocks.indexOf(window.location.search) > -1){
                $("#hgt-single-stock-list").removeClass('hqlist-tab-item')
                $("#hgt-single-stock-list").addClass('hqlist-tab-item-active')
                $("#hgt-single-fund-list").addClass('hqlist-tab-item')
                $("#hgt-single-fund-list").removeClass('hqlist-tab-item-active')
            }else if(singleFunds.indexOf(window.location.search) > -1){
                $("#hgt-single-fund-list").removeClass('hqlist-tab-item')
                $("#hgt-single-fund-list").addClass('hqlist-tab-item-active')
                $("#hgt-single-stock-list").addClass('hqlist-tab-item')
                $("#hgt-single-stock-list").removeClass('hqlist-tab-item-active')
            }
        })  
        return quotetable
    },
    makehushengangtongAhTable: function(url) {
        let self = this
        let quotetable = new QuoteTable({
            ele: 'listtable',
            api: `${url}`,
            params: { // 默认参数配置
                sortkey: 'f188',
                sortval: '1',
                size: '20'
            },
            right_tds: 3,
            refresh: 15,
            sortdesc:'1',
            sortacr:'0',
            item: [
                {
                    name: 'name',
                    title: '名称',
                    html: function (data) {
                        if (data == null) {
                            return `<th>${this.title}</th>`
                        } else {
                            return `<td><p>${data.f14}</p></td>`
                        }
                    },
                    sort: false
                },
                {
                    name: 'zx',
                    title: 'A股报价',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th>${this.title}</th>`
                        } else {
                            return `
                            <td>
                                <p class=${data.f187 > 0 ? 'shares-rise' : (data.f187 < 0 ? 'shares-fall' : '')}>${self.numberFix(data.f186,data.f190)}</p>
                                <p class=${data.f187 > 0 ? 'shares-rise' : (data.f187 < 0 ? 'shares-fall' : '')}>${self.dataProcess(data.f187,data.f152,'%')}</p>
                            </td>`
                        }
                    },
                    sort: false
                },
                {
                    name: 'zf',
                    title: 'H股报价',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th>${this.title}</th>`
                        } else {
                            return `<td>
                                <p class=${data.f4 > 0 ? 'shares-rise' : (data.f4 < 0 ? 'shares-fall' : '')}>${self.numberFix(data.f2,data.f1)}</p>
                                <p class=${data.f4 > 0 ? 'shares-rise' : (data.f4 < 0 ? 'shares-fall' : '')}>${self.dataProcess(data.f3,data.f152,'%')}</p>
                            </td>`
                        }
                    },
                    sort: false,
                },
                {
                    name: 'zd',
                    title: '溢价(A/H)',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_des">${this.title}</th>`
                        } else {
                            return `<td class=${data.f188 > 0 ? 'shares-rise' : (data.f188 < 0 ? 'shares-fall' : '')}>${self.dataProcess(data.f188,data.f152,'%')}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '0',
                        ascvalue: '1',
                        key: 'f4'
                    }
                }
            ]
        })
        quotetable.init().then(function(){
            if(location.search.indexOf('ahguyijia') < 0){
                if(navigator.userAgent.toLowerCase().indexOf('ipad') > -1 || navigator.userAgent.toLowerCase().indexOf('pad') > -1){
                    $(".hqlist-table .table-title").css('top','6.5rem')
                }else{
                    $(".hqlist-table .table-title").css('top','8rem')
                }
            }    
        })
        return quotetable
    },
    makehuluntongTable: function(url) {
        let self = this
        let quotetable = new QuoteTable({
            ele: 'listtable',
            api: `${url}`,
            params: { // 默认参数配置
                sortkey: 'f3',
                sortval: '1',
                size: '20'
            },
            right_tds: 2,
            refresh: 15,
            sortdesc:'1',
            sortacr:'0',
            item: [
                {
                    name: 'name',
                    title: '名称',
                    html: function (data) {
                        if (data == null) {
                            return `<th>${this.title}</th>`
                        } else {
                            let icon = ''
                            if ((data.f13 == 1) && (data.f19 == 23)) {
                                icon = icon + "<span class='icon-kc'>科创</span>"
                            }
                            if ((data.f13 == 0) && (data.f111 & 2048)){
                                icon = icon + "<span class='icon-kc'>京</span>"
                            }
                            if (data.f148 & 64) {
                                icon = icon + "<span class='icon-rz'>融</span>"
                            }
                            return `<td><p>${data.f14}</p><p>${data.f12}${icon}</p></td>`
                        }
                    },
                    sort: false
                },
                {
                    name: 'zx',
                    title: '最新',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th value="true" class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td class="${data.f3 > 0 ? 'shares-rise' : (data.f3<0?'shares-fall':'') }">${self.numberFix(data.f2,data.f1)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f2'
                    }
                },
                {
                    name: 'zf',
                    title: '涨幅',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_des">${this.title}</th>`
                        } else {
                            return `<td class="${data.f3 > 0 ? 'shares-rise' : (data.f3<0?'shares-fall':'') }">${self.dataProcess(data.f3,data.f152,'%')}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '0',
                        ascvalue: '1',
                        key: 'f3'
                    }
                },
                {
                    name: 'zd',
                    title: '涨跌',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td class="${data.f4 > 0 ? 'shares-rise' : (data.f4<0?'shares-fall':'') }">${self.numberFix(data.f4,data.f1)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f4'
                    }
                },
                {
                    name: 'zl',
                    title: '总手',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td>${self.conversion(data.f5,false,true,true)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f5'
                    }
                },
                {
                    name: 'zg',
                    title: '最高价',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td class="${data.f15 > data.f18 ? 'shares-rise' : (data.f15 < data.f18?'shares-fall':'') }">${self.numberFix(data.f15,data.f1)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f15'
                    }
                },
                {
                    name: 'zd',
                    title: '最低价',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td class="${data.f16 > data.f18 ? 'shares-rise' : (data.f16 < data.f18?'shares-fall':'') }">${self.numberFix(data.f16,data.f1)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f16'
                    }
                },
                {
                    name: 'kpj',
                    title: '开盘价',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td class="${data.f17 > data.f18 ? 'shares-rise' : (data.f17 < data.f18?'shares-fall':'') }">${self.numberFix(data.f17,data.f1)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f17'
                    }
                }
            ]
        })
        let data = quotetable.init(true)
        data.then(function(e){
            if(e.data == null){
                $("#list-loadmore").html('暂无数据')
            }
        })
        return quotetable
    },
    makehuluntongyijiagdrTable: function(url) {
        let self = this
        let quotetable = new QuoteTable({
            ele: 'listtable',
            api: `${url}`,
            params: { // 默认参数配置
                sortkey: 'f119',
                sortval: '1',
                size: '20'
            },
            right_tds: 3,
            refresh: 15,
            sortdesc:'1',
            sortacr:'0',
            item: [
                {
                    name: 'name',
                    title: '名称',
                    html: function (data) {
                        if (data == null) {
                            return `<th>${this.title}</th>`
                        } else {
                            let icon = ''
                            if ((data.f13 == 1) && (data.f19 == 23)) {
                                icon = icon + "<span class='icon-kc'>科创</span>"
                            }
                            if ((data.f13 == 0) && (data.f111 & 2048)){
                                icon = icon + "<span class='icon-kc'>京</span>"
                            }
                            if (data.f148 & 64) {
                                icon = icon + "<span class='icon-rz'>融</span>"
                            }
                            return `<td><p>${data.f14}</p><p>${data.f12}${icon}</p></td>`
                        }
                    },
                    sort: false
                },
                {
                    name: 'ahbj',
                    title: 'A股报价',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th>${this.title}</th>`
                        } else {
                            return `<td>
                            <p class=${data.f118 > 0 ? 'shares-rise' : (data.f118 < 0 ? 'shares-fall' : '')}>${self.numberFix(data.f117,data.f120)}</p>
                            <p class=${data.f118 > 0 ? 'shares-rise' : (data.f118 < 0 ? 'shares-fall' : '')}>${self.dataProcess(data.f118,data.f152,'%')}</p>
                            </td>`
                        }
                    }
                },
                {
                    name: 'gdrbj',
                    title: 'GDR报价',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th>${this.title}</th>`
                        } else {
                            return `<td>
                            <p class=${data.f3 > 0 ? 'shares-rise' : (data.f3 < 0 ? 'shares-fall' : '')}>${self.numberFix(data.f2,data.f1)}</p>
                            <p class=${data.f3 > 0 ? 'shares-rise' : (data.f3 < 0 ? 'shares-fall' : '')}>${self.dataProcess(data.f3,data.f152,'%')}</p>
                            </td>`
                        }
                    }
                },
                {
                    name: 'yj',
                    title: '溢价(GDR/A)',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_des" style="padding:0.5rem 0rem 0.5rem 0;">${this.title}</th>`
                        } else {
                            return `<td class=${data.f119 > 0 ? 'shares-rise' : (data.f119 < 0 ? 'shares-fall' : '')}>${self.dataProcess(data.f119,data.f152,'%')}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f119'
                    }
                }
            ]
        })
        let data = quotetable.init(true)
        data.then(function(e){
            if(e.data == null){
                $("#list-loadmore").html('暂无数据')
            }
        })
        return quotetable
    },
    makehuluntongyijiacdrTable: function(url) {
        let self = this
        let quotetable = new QuoteTable({
            ele: 'listtable',
            api: `${url}`,
            params: { // 默认参数配置
                sortkey: 'f119',
                sortval: '1',
                size: '20'
            },
            right_tds: 3,
            refresh: 15,
            sortdesc:'1',
            sortacr:'0',
            item: [
                {
                    name: 'name',
                    title: '名称',
                    html: function (data) {
                        if (data == null) {
                            return `<th>${this.title}</th>`
                        } else {
                            let icon = ''
                            if ((data.f13 == 1) && (data.f19 == 23)) {
                                icon = icon + "<span class='icon-kc'>科创</span>"
                            }
                            if ((data.f13 == 0) && (data.f111 & 2048)){
                                icon = icon + "<span class='icon-kc'>京</span>"
                            }
                            if (data.f148 & 64) {
                                icon = icon + "<span class='icon-rz'>融</span>"
                            }
                            return `<td><p>${data.f14}</p><p>${data.f12}${icon}</p></td>`
                        }
                    },
                    sort: false
                },
                {
                    name: 'ahbj',
                    title: '英股报价',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th>${this.title}</th>`
                        } else {
                            return `<td>
                            <p class=${data.f118 > 0 ? 'shares-rise' : (data.f118 < 0 ? 'shares-fall' : '')}>${self.numberFix(data.f117,data.f120)}</p>
                            <p class=${data.f118 > 0 ? 'shares-rise' : (data.f118 < 0 ? 'shares-fall' : '')}>${self.dataProcess(data.f118,data.f152,'%')}</p>
                            </td>`
                        }
                    }
                },
                {
                    name: 'gdrbj',
                    title: 'CDR报价',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th>${this.title}</th>`
                        } else {
                            return `<td>
                            <p class=${data.f3 > 0 ? 'shares-rise' : (data.f3 < 0 ? 'shares-fall' : '')}>${self.numberFix(data.f2,data.f1)}</p>
                            <p class=${data.f3 > 0 ? 'shares-rise' : (data.f3 < 0 ? 'shares-fall' : '')}>${self.dataProcess(data.f3,data.f152,'%')}</p>
                            </td>`
                        }
                    }
                },
                {
                    name: 'yj',
                    title: '溢价(CDR/A)',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_des" style="padding:0.5rem 0rem 0.5rem 0;">${this.title}</th>`
                        } else {
                            return `<td class=${data.f119 > 0 ? 'shares-rise' : (data.f119 < 0 ? 'shares-fall' : '')}>${self.dataProcess(data.f119,data.f152,'%')}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f119'
                    }
                }
            ]
        })
        let data = quotetable.init(true)
        data.then(function(e){
            if(e.data == null){
                $("#list-loadmore").html('暂无数据')
            }
        })
        return quotetable
    },
    conversion(num: number, isSign: boolean, isUnit: boolean ,isInteger:boolean = false) {
        let numSign: string
        let self = this
        if (isSign) {
          if (num < 0) {
            numSign = '-'
          } else if (num == 0) {
            numSign = ''
          } else {
            numSign = '+'
          }
        } else {
          numSign = ''
        }
        if (Math.abs(num) == 0) {
          return 0
        } else if (Math.abs(num) > 0 && Math.abs(num) < 1) {
            if(isInteger){
                return Math.abs(num)
            }else{
                return numSign + self.numberFix(Math.abs(num), 3)
            }
        } else if (Math.abs(num) >= 1 && Math.abs(num) < 100) {
            if(isInteger){
                return Math.abs(num)
            }else{
                return numSign + self.numberFix(Math.abs(num), 2)
            }
        } else if (Math.abs(num) >= 100 && Math.abs(num) < 1000) {
            if(isInteger){
                return Math.abs(num)
            }else{
                return numSign + self.numberFix(Math.abs(num), 1)
            }
        } else if (Math.abs(num) >= 1000 && Math.abs(num) < 10000) {
          return numSign + self.numberFix(Math.abs(num), 0)
        } else if (Math.abs(num) >= 10000 && Math.abs(num) < 1000000) {
          if (isUnit) {
            return numSign + self.numberFix(Math.abs(num) / 10000, 2) + '万'
          } else {
            return numSign + self.numberFix(Math.abs(num) / 10000, 2)
          }
        } else if (Math.abs(num) >= 1000000 && Math.abs(num) < 10000000) {
          if (isUnit) {
            return numSign + self.numberFix(Math.abs(num) / 10000, 1) + '万'
          } else {
            return numSign + self.numberFix(Math.abs(num) / 10000, 1)
          }
        } else if (Math.abs(num) >= 10000000 && Math.abs(num) < 100000000) {
          if (isUnit) {
            return numSign + self.numberFix(Math.abs(num) / 10000, 0) + '万'
          } else {
            return numSign + self.numberFix(Math.abs(num) / 10000, 0)
          }
        } else if (Math.abs(num) >= 100000000 && Math.abs(num) < 10000000000) {
          if (isUnit) {
            return numSign + self.numberFix(Math.abs(num) / 100000000, 2) + '亿'
          } else {
            return numSign + self.numberFix(Math.abs(num) / 100000000, 2)
          }
        } else if (Math.abs(num) >= 10000000000 && Math.abs(num) < 100000000000) {
          if (isUnit) {
            return numSign + self.numberFix(Math.abs(num) / 100000000, 1) + '亿'
          } else {
            return numSign + self.numberFix(Math.abs(num) / 100000000, 1)
          }
        } else if (Math.abs(num) >= 100000000000 && Math.abs(num) < 1000000000000) {
          if (isUnit) {
            return numSign + self.numberFix(Math.abs(num) / 100000000, 0) + '亿'
          } else {
            return numSign + self.numberFix(Math.abs(num) / 100000000, 0)
          }
        } else if (Math.abs(num) >= 1000000000000 && Math.abs(num) < 10000000000000) {
          if (isUnit) {
            return numSign + self.numberFix(Math.abs(num) / 1000000000000, 1) + '万亿'
          } else {
            return numSign + self.numberFix(Math.abs(num) / 1000000000000, 1)
          }
        } else if (Math.abs(num) >= 10000000000000) {
          if (isUnit) {
            return numSign + self.numberFix(Math.abs(num) / 1000000000000, 0) + '万亿'
          } else {
            return numSign + self.numberFix(Math.abs(num) / 1000000000000, 0)
          }
        }else{
            return '-'
        }
    },
    numberFix(num: number, n: number) {
        var f = parseFloat(String(num));
        if (isNaN(f)) {
          return '-';
        }
        var f = Math.round(num * Math.pow(10, n)) / Math.pow(10, n);
        if (n == 0) {
          return f
        } else {
          var s = f.toString();
          var rs = s.indexOf('.');
          if (rs < 0) {
            rs = s.length;
            s += '.';
          }
          while (s.length <= rs + n) {
            s += '0';
          }
          return s;
        }
    },
    dataProcess(data,num,symbol){
        let self = this
        if(data == undefined || data == null || data == '-'){
            return '-'
        }else{
            return self.numberFix(data,num) + symbol
        }
    },
    dateTrans(val:any){
        if(!val){
            return '-'
        }
        val = String(val)
        return `${val.slice(0,4)}-${val.slice(4,6)}-${val.slice(6,8)}`
    },
    formatCompareColor(value: any, value1: any) {
        if (value == null || value == "-" || value1 == null || value1 == "-") {
          return ""
        }
      
        if (value.toString() == "0" || value.toString() == "0.0" || value.toString() == "0.00" || value.toString() == "0.000" || value.toString() == "0.0000") {
          return ""
        }
      
        if (parseFloat(value) > parseFloat(value1)) {
          return "shares-rise"
        } else if (parseFloat(value) < parseFloat(value1)) {
          return "shares-fall"
        } else if (parseFloat(value) == parseFloat(value1)) {
          return ""
        }
      },
    formatTipsCompareColor(reverse:boolean, value: any, value1: any) {
        if (value == null || value == "-" || value1 == null || value1 == "-") {
          return ""
        }
      
        if (value.toString() == "0" || value.toString() == "0.0" || value.toString() == "0.00" || value.toString() == "0.000" || value.toString() == "0.0000") {
          return ""
        }
      
        if(reverse){
          if (parseFloat(value) < parseFloat(value1)) {
            return "shares-rise"
          } else if (parseFloat(value) > parseFloat(value1)) {
            return "shares-fall"
          } else if (parseFloat(value) == parseFloat(value1)) {
            return ""
          }
        }else{
          if (parseFloat(value) > parseFloat(value1)) {
            return "shares-rise"
          } else if (parseFloat(value) < parseFloat(value1)) {
            return "shares-fall"
          } else if (parseFloat(value) == parseFloat(value1)) {
            return ""
          }
        }
    },
    formatDate(thisdate: any, format: any) {
        if(thisdate == null || thisdate == "-" || isNaN(thisdate)){
          return "-"
        }
        thisdate = new Date(thisdate)
        let o: any = {
          "M+": thisdate.getMonth() + 1, //month
          "d+": thisdate.getDate(), //day
          "h+": thisdate.getHours(), //hour
          "m+": thisdate.getMinutes(), //minute
          "s+": thisdate.getSeconds(), //second
          "q+": Math.floor((thisdate.getMonth() + 3) / 3), //quarter
          S: thisdate.getMilliseconds(), //millisecond
        }
        if (/(y+)/.test(format)) {
          format = format.replace(RegExp.$1, (thisdate.getFullYear() + "").substring(4 - RegExp.$1.length))
        }
        for (let k in o) {
          if (new RegExp("(" + k + ")").test(format)) {
            format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substring(("" + o[k]).length))
          }
        }
        return format
    },
    formatUniqueNumToFixed(value: any, rate: number, tofixed: number, suffix = "") {
        if (value == "-" || value == undefined || isNaN(value)) return "-"
        let num = Number(value)
        let r = Number(rate)
        let temp = Math.pow(10, r)
      
        if (num) {
          return (num / temp).toFixed(tofixed) + suffix
        } else {
          return num.toFixed(tofixed) + suffix
        }
    },
    getTipsClassName(reverse:boolean,data:any){
        if(reverse){
            return data.f4 < 0 ? "shares-rise" : data.f4 > 0 ? "shares-fall" : ""
        }else{
            return data.f4 > 0 ? "shares-rise" : data.f4 < 0 ? "shares-fall" : ""
        }
    }
}

data.init()
